import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from "graphql";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

/** Input for the `addUsers` mutation. */
export type AddUserInput = {
  /** Primary key of the organization to add users to. */
  id: Scalars["Int"];
  /** One or more users to add to the organization. */
  users: Array<InputMaybe<CreateUserOrgInput>>;
};

/**
 * An art object record sourced from the Barnes Foundation's Elasticsearch index.
 * Fields are mapped directly from the raw Elasticsearch document and may be null
 * if the data was not present in the source record.
 */
export type ArtObject = {
  __typename?: "ArtObject";
  /** Honorific prefix for the artist's name (e.g. 'Dr.'). */
  artistPrefix?: Maybe<Scalars["String"]>;
  /** Honorific suffix for the artist's name. */
  artistSuffix?: Maybe<Scalars["String"]>;
  /** Bibliographic references for the work. */
  bibliography?: Maybe<Scalars["String"]>;
  /** Birth year of the primary artist. */
  birthDate?: Maybe<Scalars["String"]>;
  /** Credit line describing the work's acquisition or gift. */
  creditLine?: Maybe<Scalars["String"]>;
  /** Cultural origin of the work. */
  culture?: Maybe<Scalars["String"]>;
  /** Whether the work has received curatorial approval for display. */
  curatorialApproval?: Maybe<Scalars["String"]>;
  /** Death year of the primary artist. */
  deathDate?: Maybe<Scalars["String"]>;
  /** Physical dimensions of the work. */
  dimensions?: Maybe<Scalars["String"]>;
  /** Display-friendly date string for the work (e.g. '1905–1906'). */
  displayDate?: Maybe<Scalars["String"]>;
  /** Index used to group works that belong to the same ensemble. */
  ensembleIndex?: Maybe<Scalars["String"]>;
  /** Exhibition history of the work. */
  exhHistory?: Maybe<Scalars["String"]>;
  /** Unique numeric identifier for the art object. */
  id?: Maybe<Scalars["Int"]>;
  /** Secret token used to construct the original-resolution image URL. */
  imageOriginalSecret?: Maybe<Scalars["String"]>;
  /** Secret token used to construct the standard image URL. */
  imageSecret?: Maybe<Scalars["String"]>;
  /** Barnes Foundation catalog inventory number for the work. */
  invno?: Maybe<Scalars["String"]>;
  /** Long descriptive text about the work. */
  longDescription?: Maybe<Scalars["String"]>;
  /** The medium or materials used (e.g. 'Oil on canvas'). */
  medium?: Maybe<Scalars["String"]>;
  /** Nationality of the primary artist. */
  nationality?: Maybe<Scalars["String"]>;
  /** Rights type identifier governing image usage. */
  objRightsTypeId?: Maybe<Scalars["String"]>;
  /** Whether the work is currently on display at the Barnes. */
  onview?: Maybe<Scalars["String"]>;
  /** Names of people associated with the work (artist, collaborators, etc.). */
  people?: Maybe<Scalars["String"]>;
  /** Published provenance history of the work. */
  publishedProvenance?: Maybe<Scalars["String"]>;
  /** Short descriptive text about the work. */
  shortDescription?: Maybe<Scalars["String"]>;
  /** Full title of the work. */
  title?: Maybe<Scalars["String"]>;
};

/**
 * An attendee record representing a participant in a Meeting.
 * Created when a user joins via `createAttendee`, and linked to a Chime attendee
 * for audio/video. The `ExternalUserId`, `AttendeeId`, and `JoinToken` fields
 * are returned directly from the Chime SDK.
 */
export type Attendee = {
  __typename?: "Attendee";
  /** Chime-assigned attendee ID. */
  AttendeeId?: Maybe<Scalars["String"]>;
  /** External user ID passed to Chime, used to correlate the attendee with an application user. */
  ExternalUserId?: Maybe<Scalars["String"]>;
  /** Chime join token used by the client SDK to authenticate into the meeting. */
  JoinToken?: Maybe<Scalars["String"]>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Device and browser info captured at join time. */
  deviceInfo?: Maybe<DeviceInfo>;
  /** Attendee's first name. */
  firstName: Scalars["String"];
  /** Icon color assigned to this attendee's avatar. */
  iconColor?: Maybe<IconColor>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Attendee's last name. */
  lastName: Scalars["String"];
  /** The Meeting this attendee belongs to. */
  meeting?: Maybe<Meeting>;
  /** Foreign key of the Meeting this attendee belongs to. */
  meetingId?: Maybe<Scalars["Int"]>;
  /** Numeric role identifier (e.g. presenter vs. viewer). */
  meetingRole?: Maybe<Scalars["Int"]>;
  /** Whether this attendee has been soft-banned from the meeting. */
  softBanned: Scalars["Boolean"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/**
 * A Board is a single slide within a Meeting. Each board has a `type` that determines
 * which associated media record is active (boardImages, boardPanorama, boardVideo, or
 * boardThreedee). Boards are ordered within a meeting by `sortOrder`.
 */
export type Board = {
  __typename?: "Board";
  /** IIIF image assets linked to this board. Populated when type is IIIF. */
  boardImages?: Maybe<Array<Maybe<BoardImage>>>;
  /** Panorama asset linked to this board. Populated when type is PANORAMA. */
  boardPanorama?: Maybe<BoardPanorama>;
  /** 3D model asset linked to this board. Populated when type is THREEDEE. */
  boardThreedee?: Maybe<BoardThreedee>;
  /** Video asset linked to this board. Populated when type is VIDEO. */
  boardVideo?: Maybe<BoardVideo>;
  /** Optional caption shown below the board content. */
  caption?: Maybe<Scalars["String"]>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** The parent Meeting. */
  meeting?: Maybe<Meeting>;
  /** Foreign key of the parent Meeting. */
  meetingId?: Maybe<Scalars["Int"]>;
  /** Zero-based position of this board within its meeting's slide list. */
  sortOrder?: Maybe<Scalars["Int"]>;
  /** Display title for the board. */
  title?: Maybe<Scalars["String"]>;
  /** The kind of content this board displays. */
  type?: Maybe<BoardType>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/**
 * A BoardImage links a Board to a single IIIF tiled image asset. A board of type IIIF
 * may have multiple BoardImage records. The optional x, y, width, and height fields
 * describe the image's position and size within the viewer layout.
 */
export type BoardImage = {
  __typename?: "BoardImage";
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Linked image layers, if present. */
  boardImageLayers?: Maybe<Array<Maybe<BoardImageLayer>>>;
  /** Display height of the image within the viewer layout. */
  height?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** The linked ImageUpload record, if present. */
  imageUpload?: Maybe<ImageUpload>;
  /** Foreign key of the linked ImageUpload record, if this image was uploaded via the platform. */
  imageUploadId?: Maybe<Scalars["Int"]>;
  /** IIIF tile source URL used by the image viewer to load the tiled image. */
  tileSource?: Maybe<Scalars["String"]>;
  /** Display width of the image within the viewer layout. */
  width?: Maybe<Scalars["Int"]>;
  /** Horizontal position of the image within the viewer layout. */
  x?: Maybe<Scalars["Int"]>;
  /** Vertical position of the image within the viewer layout. */
  y?: Maybe<Scalars["Int"]>;
};

/**
 * A BoardImageLayer represents a single image layer that will overlay a BoardImage
 * asset. The x, y, width, and height fields describe the layer's position and
 * size within the viewer layout. An optional ImageUpload record may be linked if the
 * image was uploaded directly through the platform.
 */
export type BoardImageLayer = {
  __typename?: "BoardImageLayer";
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** The linked BoardImage record. */
  boardImage?: Maybe<BoardImage>;
  /** Foreign key of the linked BoardImage record. */
  boardImageId?: Maybe<Scalars["Int"]>;
  /** Display height of the image within the viewer layout. */
  height?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** The linked ImageUpload record, if present. */
  imageUpload?: Maybe<ImageUpload>;
  /** Foreign key of the linked ImageUpload record, if this image was uploaded via the platform. */
  imageUploadId?: Maybe<Scalars["Int"]>;
  /** The order in which the layer appears */
  order: Scalars["Int"];
  /** IIIF tile source URL used by the image viewer to load the tiled image. */
  tileSource?: Maybe<Scalars["String"]>;
  /** Display width of the image within the viewer layout. */
  width?: Maybe<Scalars["Int"]>;
  /** Horizontal position of the image within the viewer layout. */
  x?: Maybe<Scalars["Int"]>;
  /** Vertical position of the image within the viewer layout. */
  y?: Maybe<Scalars["Int"]>;
};

/** A join record linking a Board to a Panorama asset. A board of type PANORAMA has exactly one BoardPanorama. */
export type BoardPanorama = {
  __typename?: "BoardPanorama";
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** The linked Panorama. */
  panorama?: Maybe<Panorama>;
  /** Foreign key of the linked Panorama. */
  panoramaId?: Maybe<Scalars["Int"]>;
};

/** Read-only snapshot of a BoardPanorama used during meeting replay. */
export type BoardPanoramaReplay = {
  __typename?: "BoardPanoramaReplay";
  /** The linked Panorama. */
  Panorama?: Maybe<Panorama>;
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Foreign key of the linked Panorama. */
  panoramaId?: Maybe<Scalars["Int"]>;
};

/** A 3D model asset linked to a Board. A board of type THREEDEE has exactly one BoardThreedee. */
export type BoardThreedee = {
  __typename?: "BoardThreedee";
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Optional scale factor applied to the 3D model in the viewer. */
  scale?: Maybe<Scalars["Float"]>;
  /** URL of the 3D model source file. */
  sourceUrl: Scalars["String"];
};

/** The type of content displayed on a Board, which determines which associated media record is active. */
export enum BoardType {
  /** One or more IIIF tiled images. */
  IIIF = "IIIF",
  /** A 360-degree panorama. */
  PANORAMA = "PANORAMA",
  /** A 3D model. */
  THREEDEE = "THREEDEE",
  /** A video with optional start and end timestamps. */
  VIDEO = "VIDEO",
}

/** A video asset linked to a Board. A board of type VIDEO has exactly one BoardVideo. */
export type BoardVideo = {
  __typename?: "BoardVideo";
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Optional end offset in seconds for video playback. */
  end?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** URL of the video source. */
  sourceUrl: Scalars["String"];
  /** Optional start offset in seconds for video playback. */
  start?: Maybe<Scalars["Int"]>;
};

/** The type of preview image used to represent a chapter in meeting replay. */
export enum ChapterPreviewType {
  /** Preview sourced from a IIIF manifest. */
  IIIF_MANIFEST = "IIIF_MANIFEST",
  /** Preview sourced from a plain image URL. */
  IMAGE_URL = "IMAGE_URL",
  /** Preview is a 3D model. */
  THREEDEE = "THREEDEE",
  /** Preview is a video. */
  VIDEO = "VIDEO",
}

/**
 * A Course is a collection of Meetings organized under an Organization. It has a
 * human-readable `name` and a URL-friendly `slug` used for public-facing links.
 */
export type Course = {
  __typename?: "Course";
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** Meetings belonging to this course. */
  meetings?: Maybe<Array<Maybe<Meeting>>>;
  /** Display name of the course. */
  name?: Maybe<Scalars["String"]>;
  /** The Organization that owns this course. */
  organization?: Maybe<Organization>;
  /** Foreign key of the Organization that owns this course. */
  organizationId: Scalars["Int"];
  /** URL-friendly identifier for the course. */
  slug?: Maybe<Scalars["String"]>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/** Input for the `createAttendee` mutation. */
export type CreateAttendeeInput = {
  /** Device and browser information captured at join time. */
  deviceInfo?: InputMaybe<DeviceInfoInput>;
  /** Attendee's first name. */
  firstName: Scalars["String"];
  /** Attendee's last name. */
  lastName: Scalars["String"];
  /** Numeric role for the attendee within the meeting. */
  meetingRole?: InputMaybe<Scalars["Int"]>;
  /** Title of the meeting to join, used to look up the active meeting. */
  title: Scalars["String"];
};

/**
 * Input for a single image within the `createBoardImages` mutation.
 * All records in a single call must share the same `boardId`.
 */
export type CreateBoardImage = {
  /** Foreign key of the board to attach this image to. */
  boardId: Scalars["Int"];
  /** Linked image layers, if present. */
  boardImageLayerIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  /** Display height of the image within the viewer layout. */
  height?: InputMaybe<Scalars["Int"]>;
  /** Foreign key of the ImageUpload record this image was sourced from, if applicable. */
  imageUploadId?: InputMaybe<Scalars["Int"]>;
  /** IIIF tile source URL for the image. */
  tileSource?: InputMaybe<Scalars["String"]>;
  /** Display width of the image within the viewer layout. */
  width?: InputMaybe<Scalars["Int"]>;
  /** Horizontal position of the image within the viewer layout. */
  x?: InputMaybe<Scalars["Int"]>;
  /** Vertical position of the image within the viewer layout. */
  y?: InputMaybe<Scalars["Int"]>;
};

/** Input for a single image layer */
export type CreateBoardImageLayer = {
  /** Foreign key of the board to attach this image to. */
  boardId: Scalars["Int"];
  /** Foreign key of the linked BoardImage record. */
  boardImageId?: InputMaybe<Scalars["Int"]>;
  /** Display height of the image within the viewer layout. */
  height?: InputMaybe<Scalars["Int"]>;
  /** Foreign key of the ImageUpload record this image was sourced from, if applicable. */
  imageUploadId?: InputMaybe<Scalars["Int"]>;
  /** The order in which the layer appears */
  order: Scalars["Int"];
  /** IIIF tile source URL for the image. */
  tileSource?: InputMaybe<Scalars["String"]>;
  /** Display width of the image within the viewer layout. */
  width?: InputMaybe<Scalars["Int"]>;
  /** Horizontal position of the image within the viewer layout. */
  x?: InputMaybe<Scalars["Int"]>;
  /** Vertical position of the image within the viewer layout. */
  y?: InputMaybe<Scalars["Int"]>;
};

/** Input for the `createBoard` mutation. */
export type CreateBoardInput = {
  /** IIIF image URLs to attach, if type is IIIF. */
  boardImages?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  /** Panorama reference to attach, if type is PANORAMA. */
  boardPanorama?: InputMaybe<Scalars["String"]>;
  /** 3D model URL to attach, if type is THREEDEE. */
  boardThreedee?: InputMaybe<Scalars["String"]>;
  /** Video URL to attach, if type is VIDEO. */
  boardVideo?: InputMaybe<Scalars["String"]>;
  /** Optional caption for the board. */
  caption?: InputMaybe<Scalars["String"]>;
  /** Foreign key of the parent Meeting. */
  meetingId?: InputMaybe<Scalars["Int"]>;
  /** Position of the board within the meeting's slide list. */
  sortOrder: Scalars["Int"];
  /** Display title for the new board. */
  title?: InputMaybe<Scalars["String"]>;
  /** Content type for the new board. */
  type?: InputMaybe<BoardType>;
};

/** Input for the `createBoardPanorama` mutation. */
export type CreateBoardPanorama = {
  /** Foreign key of the board to assign the panorama to. */
  boardId: Scalars["Int"];
  /** Foreign key of the Panorama to link. */
  panoramaId?: InputMaybe<Scalars["Int"]>;
};

/** Input for the `createBoardThreedee` mutation. */
export type CreateBoardThreedee = {
  /** Foreign key of the board to attach the 3D model to. */
  boardId: Scalars["Int"];
  /** Optional scale factor for the 3D model in the viewer. */
  scale?: InputMaybe<Scalars["Float"]>;
  /** URL of the 3D model source file. */
  sourceUrl: Scalars["String"];
};

/** Input for the `createBoardVideo` mutation. */
export type CreateBoardVideoInput = {
  /** Foreign key of the board to assign the video to. */
  boardId: Scalars["Int"];
  /** Optional end offset in seconds for video playback. */
  end?: InputMaybe<Scalars["Int"]>;
  /** URL of the video source. */
  sourceUrl: Scalars["String"];
  /** Optional start offset in seconds for video playback. */
  start?: InputMaybe<Scalars["Int"]>;
};

/** Input for the `createCourse` mutation. */
export type CreateCourseInput = {
  /** Optional list of meetings to create and attach to the course. */
  meetings?: InputMaybe<Array<InputMaybe<CreateMeetingInput>>>;
  /** Display name of the course. */
  name?: InputMaybe<Scalars["String"]>;
  /** Foreign key of the Organization that will own this course. */
  organizationId: Scalars["Int"];
  /** URL-friendly identifier for the course. */
  slug?: InputMaybe<Scalars["String"]>;
};

/** Input for the `createDemoMeeting` mutation. */
export type CreateDemoMeetingInput = {
  /** The attendee to create and join to the demo meeting. */
  attendee?: InputMaybe<CreateAttendeeInput>;
  /** Foreign key of the Course to attach the demo meeting to. */
  courseId?: InputMaybe<Scalars["Int"]>;
  /** Scheduled meeting time as a Unix timestamp (ms). */
  meetingTime?: InputMaybe<Scalars["Float"]>;
  /** Display title of the demo meeting. */
  title?: InputMaybe<Scalars["String"]>;
};

/** Result returned by the `createDemoMeeting` mutation. */
export type CreateDemoMeetingResponse = {
  __typename?: "CreateDemoMeetingResponse";
  /** The Attendee record created for the demo user. */
  attendee?: Maybe<Attendee>;
  /** The created demo Meeting. */
  meeting?: Maybe<Meeting>;
};

/** Input for a single image within the `bulkCreateImageUploads` mutation. */
export type CreateImageUploadInput = {
  /** Optional birth year of the associated artist. */
  birthDate?: InputMaybe<Scalars["Float"]>;
  /** Optional caption for the image. */
  caption?: InputMaybe<Scalars["String"]>;
  /** Optional classification or category label. */
  classification?: InputMaybe<Scalars["String"]>;
  /** Optional credit line for the image. */
  creditLine?: InputMaybe<Scalars["String"]>;
  /** Optional cultural origin. */
  culture?: InputMaybe<Scalars["String"]>;
  /** Optional death year of the associated artist. */
  deathDate?: InputMaybe<Scalars["Float"]>;
  /** Optional physical dimensions. */
  dimensions?: InputMaybe<Scalars["String"]>;
  /** Optional display date associated with the image. */
  displayDate?: InputMaybe<Scalars["String"]>;
  /** Optional medium or materials description. */
  medium?: InputMaybe<Scalars["String"]>;
  /** Optional nationality of the associated artist. */
  nationality?: InputMaybe<Scalars["String"]>;
  /** Foreign key of the organization this image belongs to. */
  organizationId?: InputMaybe<Scalars["Int"]>;
  /** Optional names of people associated with the image. */
  people?: InputMaybe<Scalars["String"]>;
  /** Controls who can view the image's metadata. */
  permissions?: InputMaybe<MetaDataPermissions>;
  /** Optional title for the image. */
  title?: InputMaybe<Scalars["String"]>;
  /** URL of the original uploaded image. */
  uploadUrl: Scalars["String"];
  /** Optional visual description for accessibility purposes. */
  visualDescription?: InputMaybe<Scalars["String"]>;
};

/** Input for creating or editing a Meeting. */
export type CreateMeetingInput = {
  /** Whether the chat feature is enabled. */
  chat: Scalars["Boolean"];
  /** Foreign key of the parent Course. */
  courseId?: InputMaybe<Scalars["Int"]>;
  /** Primary key of an existing meeting to update. Omit when creating. */
  id?: InputMaybe<Scalars["Int"]>;
  /** Whether the instructor has audio/video enabled. */
  instructorAV: Scalars["Boolean"];
  /** Scheduled meeting time as a Unix timestamp (ms). */
  meetingTime?: InputMaybe<Scalars["Float"]>;
  /** Whether all attendees should be mute-locked by default. */
  muteLock: Scalars["Boolean"];
  /** Whether students have audio/video enabled. */
  studentAV: Scalars["Boolean"];
  /** Display title of the meeting. */
  title?: InputMaybe<Scalars["String"]>;
  /** Whether all attendees' video should be locked off by default. */
  videoOffLock?: InputMaybe<Scalars["Boolean"]>;
};

/** Input for the `createOrganization` mutation. */
export type CreateOrgInput = {
  /** Whether the organization should be active on creation. */
  isActive: Scalars["Boolean"];
  /** Display name of the new organization. */
  name: Scalars["String"];
};

/** Input for the `createPanorama` mutation. */
export type CreatePanorama = {
  /** URL of the back cube face. */
  back: Scalars["String"];
  /** URL of the bottom cube face. */
  bottom: Scalars["String"];
  /** Which library this panorama belongs to. */
  collection?: InputMaybe<PanoramaCollection>;
  /** URL of the front cube face. */
  front: Scalars["String"];
  /** URL of the left cube face. */
  left: Scalars["String"];
  /** Display name of the panorama. */
  name: Scalars["String"];
  /** URL of the right cube face. */
  right: Scalars["String"];
  /** URL of the composite panorama source image. */
  sourceUrl: Scalars["String"];
  /** URL of the top cube face. */
  top: Scalars["String"];
};

/** Input for the `createUser` mutation. */
export type CreateUserInput = {
  /** User's email address. */
  email?: InputMaybe<Scalars["String"]>;
  /** User's first name. */
  firstName?: InputMaybe<Scalars["String"]>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars["String"]>;
};

/**
 * Input for adding a user to an organization.
 * Provide either `userId` to link an existing user, or `user` to create a new user
 * and link them in the same operation.
 */
export type CreateUserOrgInput = {
  /** Foreign key of the Role to grant the user within the organization. */
  roleId: Scalars["Int"];
  /** New user to create and add to the organization. Omit if linking an existing user via `userId`. */
  user?: InputMaybe<CreateUserInput>;
  /** Primary key of an existing user to add. Omit if creating a new user via `user`. */
  userId?: InputMaybe<Scalars["Int"]>;
};

/** Result returned by the `createUser` mutation. */
export type CreateUserResponse = {
  __typename?: "CreateUserResponse";
  /** Creation timestamp (Unix ms). */
  createdAt?: Maybe<Scalars["Float"]>;
  /** User's email address. */
  email: Scalars["String"];
  /** User's first name. */
  firstName: Scalars["String"];
  /** Primary key of the created user. */
  id: Scalars["Int"];
  /** User's last name. */
  lastName: Scalars["String"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt?: Maybe<Scalars["Float"]>;
};

/** Identifies the data source used to populate a MediaPipeline's raw recording data. */
export enum DataProcessor {
  /** Recording data sourced from AWS Chime media capture. */
  CHIME = "CHIME",
  /** Recording data sourced from DynamoDB event logs. */
  DYNAMO_DB = "DYNAMO_DB",
}

/** Input for the `getCoursesByMeetingDates` query. */
export type DateCourseInput = {
  /** Filter to courses with meetings starting on or before this timestamp (Unix ms). */
  endDate?: InputMaybe<Scalars["Float"]>;
  /** Restrict results to courses belonging to these organizations. */
  organizationIds: Array<InputMaybe<Scalars["Int"]>>;
  /** Filter to courses with meetings starting on or after this timestamp (Unix ms). */
  startDate?: InputMaybe<Scalars["Float"]>;
};

/** Input for the `deleteBoard` mutation. */
export type DeleteBoardInput = {
  /** Primary key of the board to delete. */
  id: Scalars["Int"];
};

/** Result returned after an attendee leaves or is removed from a Chime meeting. */
export type DeleteChimeAttendeeResponse = {
  __typename?: "DeleteChimeAttendeeResponse";
  /** Error message, if the deletion failed. */
  error?: Maybe<Scalars["String"]>;
  /** HTTP status code from the Chime API response. */
  status?: Maybe<Scalars["Int"]>;
  /** Whether the Chime attendee was successfully deleted. */
  success: Scalars["Boolean"];
};

/** Result returned by the `deleteMeeting` mutation, returning the updated parent course. */
export type DeleteMeetingResponse = {
  __typename?: "DeleteMeetingResponse";
  /** The parent Course after the meeting was deleted. */
  course?: Maybe<Course>;
};

/** Result returned by the `deleteBoard` mutation, including per-association error flags. */
export type DeletedBoard = {
  __typename?: "DeletedBoard";
  /** True if an error occurred while deleting the board record itself. */
  boardError?: Maybe<Scalars["Boolean"]>;
  /** True if an error occurred while deleting associated board images. */
  boardImagesError?: Maybe<Scalars["Boolean"]>;
  /** True if an error occurred while deleting the associated panorama. */
  boardPanoramaError?: Maybe<Scalars["Boolean"]>;
  /** True if an error occurred while deleting the associated video. */
  boardVideoError?: Maybe<Scalars["Boolean"]>;
  /** New presentation version number, if the meeting was recording when the board was deleted. */
  currentVersion?: Maybe<Scalars["Int"]>;
  /** Primary key of the deleted board. */
  id?: Maybe<Scalars["Int"]>;
  /** Human-readable confirmation message. */
  message?: Maybe<Scalars["String"]>;
};

/** Result returned by the `deleteBoardImage` mutation. */
export type DeletedBoardImage = {
  __typename?: "DeletedBoardImage";
  /** New presentation version number, if the meeting was recording when the image was deleted. */
  currentVersion?: Maybe<Scalars["Int"]>;
  /** Primary key of the deleted board image. */
  id?: Maybe<Scalars["Int"]>;
  /** Human-readable confirmation message. */
  message?: Maybe<Scalars["String"]>;
};

/** Result returned by the `deleteCourse` mutation. */
export type DeletedCourse = {
  __typename?: "DeletedCourse";
  /** Primary key of the deleted course. */
  id?: Maybe<Scalars["Int"]>;
  /** Human-readable confirmation message. */
  message?: Maybe<Scalars["String"]>;
};

/** Browser and device information captured when an attendee joins a meeting. */
export type DeviceInfo = {
  __typename?: "DeviceInfo";
  /** Name of the browser (e.g. 'Chrome'). */
  browserName?: Maybe<Scalars["String"]>;
  /** Version string of the browser. */
  browserVersion?: Maybe<Scalars["String"]>;
  /** Model name of the device (e.g. 'iPhone'). */
  deviceModel?: Maybe<Scalars["String"]>;
  /** Category of device (e.g. 'mobile', 'tablet'). */
  deviceType?: Maybe<Scalars["String"]>;
  /** Hardware vendor of the device (e.g. 'Apple'). */
  deviceVendor?: Maybe<Scalars["String"]>;
  /** Rendering engine (e.g. 'Blink'). */
  engine?: Maybe<Scalars["String"]>;
  /** Operating system name (e.g. 'macOS'). */
  os?: Maybe<Scalars["String"]>;
  /** Operating system version string. */
  osVersion?: Maybe<Scalars["String"]>;
  /** Raw user agent string from the browser. */
  userAgent?: Maybe<Scalars["String"]>;
};

/** Device and browser information provided by the client when joining a meeting. */
export type DeviceInfoInput = {
  /** Name of the browser. */
  browserName?: InputMaybe<Scalars["String"]>;
  /** Version string of the browser. */
  browserVersion?: InputMaybe<Scalars["String"]>;
  /** Model name of the device. */
  deviceModel?: InputMaybe<Scalars["String"]>;
  /** Category of device. */
  deviceType?: InputMaybe<Scalars["String"]>;
  /** Hardware vendor of the device. */
  deviceVendor?: InputMaybe<Scalars["String"]>;
  /** Rendering engine. */
  engine?: InputMaybe<Scalars["String"]>;
  /** Operating system name. */
  os?: InputMaybe<Scalars["String"]>;
  /** Operating system version string. */
  osVersion?: InputMaybe<Scalars["String"]>;
  /** Raw user agent string from the browser. */
  userAgent?: InputMaybe<Scalars["String"]>;
};

/** Input for the `duplicateBoard` mutation. */
export type DuplicateBoardInput = {
  /** Primary key of the board to duplicate. */
  id: Scalars["Int"];
  /** If true, the duplicate is inserted immediately after the source board; otherwise it is appended at the end. */
  makeNext?: InputMaybe<Scalars["Boolean"]>;
};

/**
 * Input for the `duplicateCourse` mutation.
 * Creates a full copy of the course under the given name and slug, optionally
 * reassigning it to a different organization. `meetingDates` provides replacement
 * date/time values for the duplicated meetings.
 */
export type DuplicateCourseInput = {
  /** Primary key of the course to duplicate. */
  id: Scalars["Int"];
  /** Date overrides for each duplicated meeting, in the same order as the source meetings. */
  meetingDates?: InputMaybe<Array<InputMaybe<CreateMeetingInput>>>;
  /** Display name for the duplicated course. */
  name?: InputMaybe<Scalars["String"]>;
  /** Organization to assign the duplicate to. Defaults to the source course's organization. */
  organizationId?: InputMaybe<Scalars["Int"]>;
  /** URL-friendly identifier for the duplicated course. */
  slug?: InputMaybe<Scalars["String"]>;
};

/** Input for the `duplicateMeeting` mutation. */
export type DuplicateMeetingInput = {
  /** Whether the chat feature is enabled. */
  chat: Scalars["Boolean"];
  /** Whether the instructor has audio/video enabled. */
  instructorAV: Scalars["Boolean"];
  /** Primary key of the meeting to duplicate. */
  meetingId: Scalars["Int"];
  /** Scheduled time for the duplicated meeting as a Unix timestamp (ms). */
  meetingTime?: InputMaybe<Scalars["Float"]>;
  /** Whether all attendees should be mute-locked by default. */
  muteLock: Scalars["Boolean"];
  /** Whether students have audio/video enabled. */
  studentAV: Scalars["Boolean"];
  /** Whether all attendees' video should be locked off by default. */
  videoOffLock?: InputMaybe<Scalars["Boolean"]>;
};

/** Input for the `editBoard` mutation. */
export type EditBoardInput = {
  /** Updated caption. */
  caption?: InputMaybe<Scalars["String"]>;
  /** Primary key of the board to edit. */
  id: Scalars["Int"];
  /** Updated position within the meeting's slide list. */
  sortOrder?: InputMaybe<Scalars["Int"]>;
  /** Updated display title. */
  title?: InputMaybe<Scalars["String"]>;
  /** Updated content type. */
  type?: InputMaybe<BoardType>;
};

/**
 * Input for the `editCourse` mutation.
 * The `meetings` array is treated as a desired-state list: meetings in the array that
 * do not yet exist are created, and meetings not in the array are left unchanged.
 */
export type EditCourseInput = {
  /** Primary key of the course to edit. */
  id: Scalars["Int"];
  /** Desired set of meetings for the course. */
  meetings?: InputMaybe<Array<InputMaybe<CreateMeetingInput>>>;
  /** Updated display name. */
  name?: InputMaybe<Scalars["String"]>;
};

/** Input for the `endMeeting` mutation. */
export type EndMeetingInput = {
  /** Primary key of the meeting to end. */
  id: Scalars["Int"];
  /** If true, marks the most recent MediaPipeline as the replay recording before ending. */
  setReplayRecording?: InputMaybe<Scalars["Boolean"]>;
};

/** Result returned by the `endMeeting` mutation. */
export type EndMeetingResponse = {
  __typename?: "EndMeetingResponse";
  /** Error message if the meeting could not be ended. */
  error?: Maybe<Scalars["String"]>;
  /** HTTP status code of the Chime end-meeting response. */
  status?: Maybe<Scalars["Int"]>;
  /** Whether the meeting was successfully ended. */
  success?: Maybe<Scalars["Boolean"]>;
};

/** A runtime feature toggle. Flags with `active: true` enable the corresponding feature. */
export type FeatureFlag = {
  __typename?: "FeatureFlag";
  /** Whether this flag is currently enabled. */
  active: Scalars["Boolean"];
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** Unique name identifying the flag. */
  name: Scalars["String"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/** Named feature flag values used to identify flags by their well-known name. */
export enum FeatureFlagType {
  /** Controls unauthenticated access to the /demo endpoint. */
  DEMO = "DEMO",
  /** Enables the ability to duplicate a course. */
  DUPLICATE_COURSE = "DUPLICATE_COURSE",
  /** Example flag that is disabled — used for testing flag behavior. */
  EXAMPLE_OFF_FEATURE = "EXAMPLE_OFF_FEATURE",
  /** Example flag that is enabled — used for testing flag behavior. */
  EXAMPLE_ON_FEATURE = "EXAMPLE_ON_FEATURE",
  /** Enables recording async content in full HD. */
  FHD_RECORDING = "FHD_RECORDING",
  /** Enables the in-class laser pointer tool. */
  LASER_POINTER = "LASER_POINTER",
  /** Enables the student lobby feature. */
  LOBBY = "LOBBY",
  /** Enables the moderator role for meeting attendees. */
  MODERATION = "MODERATION",
  /** Enables the end-of-class prompt to set the replay recording and trigger processing. */
  RECORDING_PROMPT = "RECORDING_PROMPT",
  /** Allows users to set the replay recording for previously recorded classes. */
  RECORDING_SET_PREVIOUS = "RECORDING_SET_PREVIOUS",
  /** Enables meeting replay for classes. */
  REPLAY = "REPLAY",
  /** Shows the replay demo option in the admin menu. */
  REPLAY_DEMO = "REPLAY_DEMO",
  /** Enables firstName and lastName query parameters on the /meeting URL. */
  USER_PARAMS = "USER_PARAMS",
}

/** Processing status for VTT file generation jobs on a MediaPipeline. */
export enum GenerateVttStatus {
  /** An error occurred during VTT generation. Pipelines in this state will be retried. */
  ERROR = "ERROR",
  /** One or more required source files were missing. Pipelines in this state will not be retried. */
  ERROR_MISSING_FILES = "ERROR_MISSING_FILES",
  /** The pipeline data has been sent to the VTT generation service and is being processed. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The VTT file was manually updated. Pipelines in this state will skip re-running the job. */
  MANUAL_UPDATE = "MANUAL_UPDATE",
  /** No VTT generation action has been taken yet. */
  PENDING = "PENDING",
  /** The pipeline has been queued for VTT generation. */
  QUEUED = "QUEUED",
  /** VTT files were successfully generated. */
  SUCCESS = "SUCCESS",
}

/** Hex color code (prefixed with underscore for GraphQL enum compatibility) used for an attendee's avatar icon. */
export enum IconColor {
  _0091EA = "_0091EA",
  _00ACC1 = "_00ACC1",
  _00CED1 = "_00CED1",
  _04A0C4 = "_04A0C4",
  _038D3E = "_038D3E",
  _0457A2 = "_0457A2",
  _0F3765 = "_0F3765",
  _1A44AF = "_1A44AF",
  _1E863C = "_1E863C",
  _2C1276 = "_2C1276",
  _3A6B00 = "_3A6B00",
  _3CB371 = "_3CB371",
  _4B371C = "_4B371C",
  _5C0E32 = "_5C0E32",
  _6A2D80 = "_6A2D80",
  _6A7BCB = "_6A7BCB",
  _6D1D00 = "_6D1D00",
  _6DAE43 = "_6DAE43",
  _6F0400 = "_6F0400",
  _7A19AB = "_7A19AB",
  _8E003C = "_8E003C",
  _18A278 = "_18A278",
  _135B7F = "_135B7F",
  _253B6A = "_253B6A",
  _285E73 = "_285E73",
  _316C8B = "_316C8B",
  _511AAC = "_511AAC",
  _620F53 = "_620F53",
  _900C3F = "_900C3F",
  _1004B3 = "_1004B3",
  _1627FD = "_1627FD",
  _2962FF = "_2962FF",
  _3752FA = "_3752FA",
  _5082C2 = "_5082C2",
  _7295CE = "_7295CE",
  _8352FD = "_8352FD",
  _9370DB = "_9370DB",
  _13277C = "_13277C",
  _87001B = "_87001B",
  _191279 = "_191279",
  _581845 = "_581845",
  _712868 = "_712868",
  _AB47BC = "_AB47BC",
  _AB1960 = "_AB1960",
  _AC0062 = "_AC0062",
  _B50053 = "_B50053",
  _BE1C38 = "_BE1C38",
  _C2005F = "_C2005F",
  _C70039 = "_C70039",
  _DC2176 = "_DC2176",
  _E65883 = "_E65883",
  _EC407A = "_EC407A",
  _F08080 = "_F08080",
  _FF6F61 = "_FF6F61",
  _FF367F = "_FF367F",
  _FF1493 = "_FF1493",
  _FF3587 = "_FF3587",
  _FFBF00 = "_FFBF00",
  _FFC300 = "_FFC300",
  _FFD700 = "_FFD700",
}

/** Processing status of the IIIF tiled-image conversion for an uploaded image. */
export enum IiiFConversionStatus {
  /** An error occurred during conversion. Images in this state will be retried. */
  ERROR = "ERROR",
  /** The image data has been sent to the IIIF conversion service and is being processed. */
  IN_PROGRESS = "IN_PROGRESS",
  /** No conversion action has been taken yet. */
  PENDING = "PENDING",
  /** The image has been queued for IIIF conversion. */
  QUEUED = "QUEUED",
  /** The uploaded image was too small to convert to IIIF. Images in this state will not be retried. */
  SIZE_ERROR = "SIZE_ERROR",
  /** The image was successfully converted to IIIF tiles. */
  SUCCESS = "SUCCESS",
}

/** Request body sent to the IIIF conversion service for a single image. */
export type IiifConversionReqBody = {
  __typename?: "IiifConversionReqBody";
  /** S3 bucket where the generated IIIF tiles will be written. */
  outputBucket: Scalars["String"];
  /** Base name for the output tile files. */
  outputName?: Maybe<Scalars["String"]>;
  /** URL of the source image to convert. */
  sourceURL: Scalars["String"];
};

/** Response returned by the IIIF conversion service after processing an image. */
export type IiifConversionResponse = {
  __typename?: "IiifConversionResponse";
  /** Human-readable status message from the conversion service. */
  message?: Maybe<Scalars["String"]>;
  /** HTTP status code from the conversion service. */
  statusCode: Scalars["Int"];
  /** S3 path to the root of the generated IIIF tile output. */
  tileOutputPath?: Maybe<Scalars["String"]>;
};

/**
 * An image uploaded to the platform. Stores the original upload URL alongside
 * optional metadata fields and tracks the progress of IIIF tile conversion and
 * thumbnail generation via status enums.
 */
export type ImageUpload = {
  __typename?: "ImageUpload";
  /** Optional birth year of the associated artist. */
  birthDate?: Maybe<Scalars["Float"]>;
  /** Optional caption for the image. */
  caption?: Maybe<Scalars["String"]>;
  /** Optional classification or category label. */
  classification?: Maybe<Scalars["String"]>;
  /** Optional credit line for the image. */
  creditLine?: Maybe<Scalars["String"]>;
  /** Optional cultural origin. */
  culture?: Maybe<Scalars["String"]>;
  /** Optional death year of the associated artist. */
  deathDate?: Maybe<Scalars["Float"]>;
  /** Optional physical dimensions. */
  dimensions?: Maybe<Scalars["String"]>;
  /** Optional display date associated with the image. */
  displayDate?: Maybe<Scalars["String"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Current status of the IIIF tiled-image conversion pipeline. */
  iiifConversionStatus?: Maybe<IiiFConversionStatus>;
  /** Optional medium or materials description. */
  medium?: Maybe<Scalars["String"]>;
  /** Optional nationality of the associated artist. */
  nationality?: Maybe<Scalars["String"]>;
  /** Foreign key of the organization this image belongs to, if restricted to an organization. */
  organizationId?: Maybe<Scalars["Int"]>;
  /** Optional names of people associated with the image. */
  people?: Maybe<Scalars["String"]>;
  /** Controls who can view the image's metadata. */
  permissions?: Maybe<MetaDataPermissions>;
  /** Current status of the thumbnail generation pipeline. */
  thumbnailConversionStatus?: Maybe<ThumbnailConversionStatus>;
  /** URL of the generated thumbnail, populated once thumbnail conversion succeeds. */
  thumbnailUrl?: Maybe<Scalars["String"]>;
  /** IIIF tile source URL, populated once conversion succeeds. */
  tileSource?: Maybe<Scalars["String"]>;
  /** Optional title for the image, used as display metadata. */
  title?: Maybe<Scalars["String"]>;
  /** URL of the original uploaded image. */
  uploadUrl: Scalars["String"];
  /** Foreign key of the user who uploaded the image. */
  userId: Scalars["Int"];
  /** Optional visual description for accessibility purposes. */
  visualDescription?: Maybe<Scalars["String"]>;
};

/** Represents an SQS job message dispatched to the Jobs Lambda. */
export type Job = {
  __typename?: "Job";
  concatPipelineId?: Maybe<Scalars["String"]>;
  /** If true, forces reprocessing even if the record is already in a terminal state. */
  force?: Maybe<Scalars["Boolean"]>;
  /** Primary key of the record to process (e.g. ImageUpload ID or MediaPipeline ID). */
  id?: Maybe<Scalars["Int"]>;
  /** The type of job to run. */
  name: JobName;
  /** If true, the recording concatenation step is skipped. */
  skipConcat?: Maybe<Scalars["Boolean"]>;
  /** Current status string of the job, if applicable. */
  status?: Maybe<Scalars["String"]>;
  /** Whether the job completed successfully, if a result has been received. */
  success?: Maybe<Scalars["Boolean"]>;
  /** ECS task ID for jobs that spawn a processing task. */
  taskId?: Maybe<Scalars["String"]>;
  /** Metadata about the video length, returned by recording processing jobs. */
  videoLength?: Maybe<Scalars["JSON"]>;
};

/** Identifies the type of background job dispatched to the Jobs Lambda via SQS. */
export enum JobName {
  /** Generate an attendee log artifact for a meeting. */
  GENERATE_ATTENDEE_LOG = "GENERATE_ATTENDEE_LOG",
  /** Generate a captions VTT file for meeting replay. */
  GENERATE_CAPTIONS_VTT = "GENERATE_CAPTIONS_VTT",
  /** Generate a chapters VTT file for meeting replay. */
  GENERATE_CHAPTERS_VTT = "GENERATE_CHAPTERS_VTT",
  /** Generate a chat log artifact for a meeting. */
  GENERATE_CHAT_LOG = "GENERATE_CHAT_LOG",
  /** Generate a chat VTT file for meeting replay. */
  GENERATE_CHAT_VTT = "GENERATE_CHAT_VTT",
  /** Generate an events VTT file for meeting replay. */
  GENERATE_EVENTS_VTT = "GENERATE_EVENTS_VTT",
  /** Generate a presentation log artifact for a meeting. */
  GENERATE_PRESENTATION_LOG = "GENERATE_PRESENTATION_LOG",
  /** Convert an image upload to IIIF tiles. */
  IIIF_CONVERSION = "IIIF_CONVERSION",
  /** Concatenate and process a meeting recording. */
  PROCESS_RECORDING = "PROCESS_RECORDING",
  /** Process a meeting recording, skipping the concatenation step. */
  PROCESS_RECORDING_SKIP_CONCAT = "PROCESS_RECORDING_SKIP_CONCAT",
  QUEUE_CONCAT_PIPELINE_JOBS = "QUEUE_CONCAT_PIPELINE_JOBS",
  /** Generate a thumbnail for an image upload. */
  THUMBNAIL_CONVERSION = "THUMBNAIL_CONVERSION",
  /** Update the status of an in-progress recording job. */
  UPDATE_PROCESS_RECORDING_STATUS = "UPDATE_PROCESS_RECORDING_STATUS",
}

/** Generic response returned after dispatching a job to SQS. */
export type JobResponse = {
  __typename?: "JobResponse";
  /** Human-readable status message. */
  message: Scalars["String"];
  /** HTTP status code of the SQS dispatch response. */
  statusCode: Scalars["Int"];
};

/**
 * Input for the `login` mutation.
 * Accepts identity fields from the authentication provider. If `expiresAt` is provided,
 * a demo session is created that expires at that timestamp; otherwise a standard login
 * flow is used.
 */
export type LoginInput = {
  /** Email address of the user to authenticate. */
  email?: InputMaybe<Scalars["String"]>;
  /** Optional expiry timestamp (Unix ms) for demo sessions. */
  expiresAt?: InputMaybe<Scalars["Float"]>;
  /** User's first name. */
  firstName?: InputMaybe<Scalars["String"]>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars["String"]>;
};

/** Result returned by `login` and `getAuthenticatedUser`. */
export type LoginResponse = {
  __typename?: "LoginResponse";
  /** Authenticated user's email address. */
  email?: Maybe<Scalars["String"]>;
  /** Authenticated user's first name. */
  firstName?: Maybe<Scalars["String"]>;
  /** Whether the user is currently authenticated. */
  isAuthenticated: Scalars["Boolean"];
  /** Authenticated user's last name. */
  lastName?: Maybe<Scalars["String"]>;
  /** Human-readable status message. */
  message?: Maybe<Scalars["String"]>;
  /** Organizations the user belongs to, with their associated role. */
  organizations?: Maybe<Array<Maybe<UserOrgWithRole>>>;
  /** Organization-scoped permissions for the authenticated user. */
  permissions?: Maybe<Array<Maybe<SessionPermission>>>;
};

/** Input for the `logout` mutation. */
export type LogoutInput = {
  /** Email address of the user to log out. */
  email?: InputMaybe<Scalars["String"]>;
  /** User's first name. */
  firstName: Scalars["String"];
  /** User's last name. */
  lastName: Scalars["String"];
};

/** Result returned by the `logout` mutation. */
export type LogoutResponse = {
  __typename?: "LogoutResponse";
  /** First name of the user who logged out. */
  firstName?: Maybe<Scalars["String"]>;
  /** Whether the user is still authenticated after logout (should be false on success). */
  isAuthenticated: Scalars["Boolean"];
  /** Last name of the user who logged out. */
  lastName?: Maybe<Scalars["String"]>;
  /** Human-readable status message. */
  message?: Maybe<Scalars["String"]>;
};

/**
 * A MediaPipeline tracks the full lifecycle of a meeting recording — from the initial
 * Chime media capture pipeline through concatenation, processing, and VTT file generation.
 * Each status field independently tracks the progress of a specific processing job.
 */
export type MediaPipeline = {
  __typename?: "MediaPipeline";
  /** ARN of the Chime media capture pipeline. */
  arn?: Maybe<Scalars["String"]>;
  /** Status of the attendee log generation job. */
  attendeeLogStatus: GenerateVttStatus;
  /** AWS Chime media concatenation pipeline ID. */
  awsConcatPipelineId?: Maybe<Scalars["String"]>;
  /** AWS Chime media capture pipeline ID. */
  awsPipelineId?: Maybe<Scalars["String"]>;
  /** Status of the chat log generation job. */
  chatLogStatus: GenerateVttStatus;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** The data source used to populate this pipeline's raw recording data. */
  dataProcessor: DataProcessor;
  /** S3 folder name where the raw recording chunks are stored. */
  folderName: Scalars["String"];
  /** Status of the captions VTT generation job. */
  generateCaptionsStatus: GenerateVttStatus;
  /** Status of the chapters VTT generation job. */
  generateChaptersStatus: GenerateVttStatus;
  /** Status of the chat VTT generation job. */
  generateChatStatus: GenerateVttStatus;
  /** Status of the events VTT generation job. */
  generateEventsStatus: GenerateVttStatus;
  /** Primary key. */
  id: Scalars["Int"];
  /** The Meeting this pipeline belongs to. */
  meeting?: Maybe<Meeting>;
  /** Foreign key of the Meeting this pipeline belongs to. */
  meetingId: Scalars["Int"];
  /** Status of the presentation log generation job. */
  presentationLogStatus: GenerateVttStatus;
  /** Status of the recording concatenation and processing job. */
  processRecordingStatus: ProcessRecordingStatus;
  /** Whether this pipeline's recording has been designated as the replay recording for its meeting. */
  replayRecording?: Maybe<Scalars["Boolean"]>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
  /** Duration of the processed recording in seconds. */
  videoLength?: Maybe<Scalars["Int"]>;
};

/**
 * A Meeting is a live session within a Course, backed by AWS Chime for audio/video.
 * The PascalCase fields (MeetingId, AudioHostUrl, etc.) are returned directly from
 * the Chime SDK and stored as-is.
 */
export type Meeting = {
  __typename?: "Meeting";
  /** Chime audio fallback URL for the meeting. */
  AudioFallbackUrl?: Maybe<Scalars["String"]>;
  /** Chime audio host URL for the meeting. */
  AudioHostUrl?: Maybe<Scalars["String"]>;
  /** Chime event ingestion URL. */
  EventIngestionUrl?: Maybe<Scalars["String"]>;
  /** External meeting ID passed to Chime, typically the application meeting ID. */
  ExternalMeetingId?: Maybe<Scalars["String"]>;
  /** Alias for mediaPipelines (returned by some Chime SDK responses). */
  MediaPipelines?: Maybe<Array<Maybe<MediaPipeline>>>;
  /** AWS region where the Chime meeting is hosted. */
  MediaRegion?: Maybe<Scalars["String"]>;
  /** ARN of the Chime meeting resource. */
  MeetingArn?: Maybe<Scalars["String"]>;
  /** Chime-assigned meeting ID. */
  MeetingId?: Maybe<Scalars["String"]>;
  /** Chime screen data URL. */
  ScreenDataUrl?: Maybe<Scalars["String"]>;
  /** Chime screen sharing URL. */
  ScreenSharingUrl?: Maybe<Scalars["String"]>;
  /** Chime screen viewing URL. */
  ScreenViewingUrl?: Maybe<Scalars["String"]>;
  /** Chime signaling URL. */
  SignalingUrl?: Maybe<Scalars["String"]>;
  /** Chime TURN control URL. */
  TurnControlUrl?: Maybe<Scalars["String"]>;
  /** Attendees who have joined this meeting. */
  attendees?: Maybe<Array<Maybe<Attendee>>>;
  /** Boards (slides) belonging to this meeting. */
  boards?: Maybe<Array<Maybe<Board>>>;
  /** Whether the chat feature is enabled for this meeting. */
  chat?: Maybe<Scalars["Boolean"]>;
  /** The Course this meeting belongs to. */
  course?: Maybe<Course>;
  /** Foreign key of the parent Course. */
  courseId?: Maybe<Scalars["Int"]>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Whether the meeting is currently being recorded. */
  currentlyRecording?: Maybe<Scalars["Boolean"]>;
  /** Soft-deletion timestamp (Unix ms). Null if the meeting has not been deleted. */
  deletedAt?: Maybe<Scalars["Float"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Whether the instructor has audio/video enabled for this meeting. */
  instructorAV?: Maybe<Scalars["Boolean"]>;
  /** Whether the student lobby is currently active. */
  lobbyActive?: Maybe<Scalars["Boolean"]>;
  /** Media pipelines associated with this meeting. */
  mediaPipelines?: Maybe<Array<Maybe<MediaPipeline>>>;
  /** Scheduled meeting time as a Unix timestamp (ms). */
  meetingTime?: Maybe<Scalars["Float"]>;
  /** Whether all attendees are currently mute-locked. */
  muteLock: Scalars["Boolean"];
  /** Ordered presentation version snapshots captured during recording. */
  presentationVersions?: Maybe<Array<Maybe<PresentationVersion>>>;
  /** Whether students have audio/video enabled for this meeting. */
  studentAV?: Maybe<Scalars["Boolean"]>;
  /** Display title of the meeting. */
  title: Scalars["String"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
  /** Whether all attendees' video is currently locked off. */
  videoOffLock: Scalars["Boolean"];
};

/** A structured error returned alongside a meeting mutation response when the operation fails. */
export type MeetingError = {
  __typename?: "MeetingError";
  /** The error code identifying the failure reason. */
  code: MeetingErrorCodes;
  /** Human-readable description of the error. */
  message: Scalars["String"];
};

/** Error codes returned when a meeting-related operation fails. */
export enum MeetingErrorCodes {
  /** Chime has been started for this meeting, but is no longer active. */
  CHIME_NOT_ACTIVE = "CHIME_NOT_ACTIVE",
  /** Chime has not been started for this meeting. */
  CHIME_NOT_INITIALIZED = "CHIME_NOT_INITIALIZED",
  /** The meeting was not found. */
  NOT_FOUND = "NOT_FOUND",
}

/** Controls which users can see an image upload's metadata. */
export enum MetaDataPermissions {
  /** Visible to all members of the uploading user's organization. */
  ORGANIZATION = "ORGANIZATION",
  /** Visible to all users, including unauthenticated ones. */
  PUBLIC = "PUBLIC",
  /** Visible only to the user who uploaded the image. */
  USER = "USER",
}

export type Mutation = {
  __typename?: "Mutation";
  /** Activate a meeting by creating a Chime media capture pipeline (alias for `beginRecordMeeting` used in specific flows). */
  activateMeeting?: Maybe<RecordMeetingResponse>;
  /** Add one or more users to an organization, creating or reactivating their membership. */
  addUsers?: Maybe<Organization>;
  /** Remove the current attendee from the Chime meeting and clear their session data. */
  attendeeLeaveMeeting?: Maybe<DeleteChimeAttendeeResponse>;
  /** Create a Chime media capture pipeline to begin recording the meeting. */
  beginRecordMeeting?: Maybe<RecordMeetingResponse>;
  /** Create multiple image upload records in a single call. */
  bulkCreateImageUploads?: Maybe<Array<Maybe<ImageUpload>>>;
  /** Create a new meeting and immediately start it in Chime. */
  createAndStartMeeting?: Maybe<Meeting>;
  /**
   * Join a meeting as an attendee. Creates a Chime attendee, stores the join token in
   * the session, and returns the attendee record with credentials needed by the client SDK.
   * If the meeting does not exist in Chime, it is recreated before the attendee is added.
   */
  createAttendee?: Maybe<Attendee>;
  /** Create a new board within a meeting. */
  createBoard?: Maybe<UpdateBoardResponse>;
  /**
   * Add one or more images to a board, converting the board type to IIIF if needed.
   * All input records must share the same boardId.
   */
  createBoardImages?: Maybe<UpdateBoardImageResponse>;
  /** Assign a panorama to a board, converting the board type to PANORAMA if needed. */
  createBoardPanorama?: Maybe<UpdateBoardPanoramaResponse>;
  /** Create a new 3D model record and attach it to a board. */
  createBoardThreedee?: Maybe<UpdateBoardThreedeeResponse>;
  /** Assign a video to a board, converting the board type to VIDEO if needed. */
  createBoardVideo?: Maybe<UpdateBoardVideoResponse>;
  /** Create a new course, optionally with an initial set of meetings. */
  createCourse?: Maybe<Course>;
  /** Create a demo meeting with a preloaded demo deck and join it as a demo attendee. */
  createDemoMeeting?: Maybe<CreateDemoMeetingResponse>;
  /** Create a new meeting within a course. */
  createMeeting?: Maybe<Meeting>;
  /** Create a new organization. */
  createOrganization?: Maybe<Organization>;
  /** Create a new panorama record. */
  createPanorama?: Maybe<Panorama>;
  /** Create a new user account. */
  createUser?: Maybe<CreateUserResponse>;
  /** Delete a board and all its associated media records. */
  deleteBoard?: Maybe<DeletedBoard>;
  /** Delete a single board image by primary key. */
  deleteBoardImage?: Maybe<DeletedBoardImage>;
  /** Delete a course and all its associated meetings. */
  deleteCourse?: Maybe<DeletedCourse>;
  /** Delete a meeting and return the updated parent course. */
  deleteMeeting?: Maybe<Course>;
  /** Duplicate an existing board, optionally inserting it immediately after the original. */
  duplicateBoard?: Maybe<UpdateBoardResponse>;
  /** Duplicate a course with new name, slug, and meeting dates. */
  duplicateCourse?: Maybe<Course>;
  /** Duplicate a meeting with new settings and return the updated parent course. */
  duplicateMeeting?: Maybe<Course>;
  /** Update a board's title, caption, sort order, or type. */
  editBoard?: Maybe<UpdateBoardResponse>;
  /** Update a course's name or meeting list. */
  editCourse?: Maybe<Course>;
  /** Update an existing meeting's settings. */
  editMeeting?: Maybe<Meeting>;
  /** End the Chime meeting and stop any active recording. */
  endMeeting?: Maybe<EndMeetingResponse>;
  /** Log in using the provided identity fields. Creates or updates the user session. */
  login?: Maybe<LoginResponse>;
  /** Destroy the current user session. */
  logout?: Maybe<LogoutResponse>;
  /** Remove a user from an organization by their UserOrganization join record. */
  removeUser?: Maybe<Organization>;
  /**
   * Queue a recording processing job for a pipeline whose source video has been
   * manually uploaded to S3 to replace the original Chime meeting recording.
   */
  replaceMeetingRecording?: Maybe<MediaPipeline>;
  root?: Maybe<Scalars["String"]>;
  /** Set or clear the MediaPipeline designated as the replay recording for a meeting. */
  setReplayRecordingPipeline?: Maybe<Meeting>;
  /** Set or clear the soft-ban flag for an attendee. */
  softBanAttendee?: Maybe<Attendee>;
  /** Start the Chime meeting and join as the authenticated user. */
  startAndJoinMeeting?: Maybe<StartMeetingResponse>;
  /**
   * Queue VTT file generation jobs for a batch of media pipelines.
   * Only pipelines whose relevant status column matches one of the provided `status` values are included.
   */
  startBulkGenerateVttFiles?: Maybe<Array<Maybe<MediaPipeline>>>;
  /** Queue pending image uploads for IIIF tile conversion. */
  startBulkIiiFConversion?: Maybe<Array<Maybe<ImageUpload>>>;
  /** Start concatenation pipelines for a batch of media pipelines. */
  startBulkMediaPipelineConcat?: Maybe<Array<Maybe<RecordMeetingResponse>>>;
  /** Queue pending image uploads for thumbnail generation. */
  startBulkThumbnailConversion?: Maybe<Array<Maybe<ImageUpload>>>;
  /** Start the Chime meeting in full HD mode and join as the authenticated user. */
  startFhdMeeting?: Maybe<StartMeetingResponse>;
  /** Start the concatenation pipeline for an existing media pipeline to process its meeting recording. */
  startMediaPipelineConcat?: Maybe<RecordMeetingResponse>;
  /** Toggle the mute lock for all attendees in a meeting. */
  toggleMuteLock?: Maybe<MuteLockResponse>;
  /** Toggle the video-off lock for all attendees in a meeting. */
  toggleVideoOffLock?: Maybe<VideoOffLockResponse>;
  /** Replace all user-role assignments for an organization with the provided list. */
  updateUsers?: Maybe<Organization>;
};

export type MutationActivateMeetingArgs = {
  dataProcessor?: InputMaybe<DataProcessor>;
  id: Scalars["Int"];
};

export type MutationAddUsersArgs = {
  input?: InputMaybe<AddUserInput>;
};

export type MutationAttendeeLeaveMeetingArgs = {
  id?: InputMaybe<Scalars["Int"]>;
};

export type MutationBeginRecordMeetingArgs = {
  dataProcessor?: InputMaybe<DataProcessor>;
  id: Scalars["Int"];
};

export type MutationBulkCreateImageUploadsArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateImageUploadInput>>>;
};

export type MutationCreateAndStartMeetingArgs = {
  input?: InputMaybe<CreateMeetingInput>;
};

export type MutationCreateAttendeeArgs = {
  input?: InputMaybe<CreateAttendeeInput>;
};

export type MutationCreateBoardArgs = {
  input?: InputMaybe<CreateBoardInput>;
};

export type MutationCreateBoardImagesArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateBoardImage>>>;
};

export type MutationCreateBoardPanoramaArgs = {
  input?: InputMaybe<CreateBoardPanorama>;
};

export type MutationCreateBoardThreedeeArgs = {
  input?: InputMaybe<CreateBoardThreedee>;
};

export type MutationCreateBoardVideoArgs = {
  input?: InputMaybe<CreateBoardVideoInput>;
};

export type MutationCreateCourseArgs = {
  input?: InputMaybe<CreateCourseInput>;
};

export type MutationCreateDemoMeetingArgs = {
  input?: InputMaybe<CreateDemoMeetingInput>;
};

export type MutationCreateMeetingArgs = {
  input?: InputMaybe<CreateMeetingInput>;
};

export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrgInput>;
};

export type MutationCreatePanoramaArgs = {
  input?: InputMaybe<CreatePanorama>;
};

export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};

export type MutationDeleteBoardArgs = {
  input?: InputMaybe<DeleteBoardInput>;
};

export type MutationDeleteBoardImageArgs = {
  input?: InputMaybe<Scalars["Int"]>;
};

export type MutationDeleteCourseArgs = {
  id: Scalars["Int"];
};

export type MutationDeleteMeetingArgs = {
  input?: InputMaybe<CreateMeetingInput>;
};

export type MutationDuplicateBoardArgs = {
  input?: InputMaybe<DuplicateBoardInput>;
};

export type MutationDuplicateCourseArgs = {
  input?: InputMaybe<DuplicateCourseInput>;
};

export type MutationDuplicateMeetingArgs = {
  input?: InputMaybe<DuplicateMeetingInput>;
};

export type MutationEditBoardArgs = {
  input?: InputMaybe<EditBoardInput>;
};

export type MutationEditCourseArgs = {
  input?: InputMaybe<EditCourseInput>;
};

export type MutationEditMeetingArgs = {
  input?: InputMaybe<CreateMeetingInput>;
};

export type MutationEndMeetingArgs = {
  input?: InputMaybe<EndMeetingInput>;
};

export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};

export type MutationLogoutArgs = {
  input?: InputMaybe<LogoutInput>;
};

export type MutationRemoveUserArgs = {
  input?: InputMaybe<RemoveUserInput>;
};

export type MutationReplaceMeetingRecordingArgs = {
  id: Scalars["Int"];
};

export type MutationSetReplayRecordingPipelineArgs = {
  input?: InputMaybe<SetReplayRecordingPipelineInput>;
};

export type MutationSoftBanAttendeeArgs = {
  AttendeeId: Scalars["String"];
  softBan: Scalars["Boolean"];
};

export type MutationStartAndJoinMeetingArgs = {
  id: Scalars["Int"];
  input: StartAndJoinMeetingInput;
};

export type MutationStartBulkGenerateVttFilesArgs = {
  job: JobName;
  limit?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<Array<InputMaybe<GenerateVttStatus>>>;
};

export type MutationStartBulkIiiFConversionArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type MutationStartBulkMediaPipelineConcatArgs = {
  paginate: Paginate;
};

export type MutationStartBulkThumbnailConversionArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type MutationStartFhdMeetingArgs = {
  id: Scalars["Int"];
  input: StartAndJoinMeetingInput;
};

export type MutationStartMediaPipelineConcatArgs = {
  id: Scalars["Int"];
};

export type MutationToggleMuteLockArgs = {
  id: Scalars["Int"];
  muteLock?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationToggleVideoOffLockArgs = {
  id: Scalars["Int"];
  videoOffLock?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateUsersArgs = {
  input?: InputMaybe<UpdateUsersInput>;
};

export enum Order {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * An Organization is the top-level tenant grouping users and courses together.
 * Users belong to organizations via UserOrganization join records, each carrying
 * a role that controls what the user can do within that organization.
 */
export type Organization = {
  __typename?: "Organization";
  /** Courses belonging to this organization. */
  courses?: Maybe<Array<Maybe<Course>>>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** Whether the organization is currently active. */
  isActive: Scalars["Boolean"];
  /** Display name of the organization. */
  name: Scalars["String"];
  /** Users whose membership has been revoked. */
  revokedUsers?: Maybe<Array<Maybe<User>>>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
  /** UserOrganization join records linking users to this organization with their roles. */
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  /** Users who are members of this organization. */
  users?: Maybe<Array<Maybe<User>>>;
};

export type Paginate = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
};

/**
 * A Panorama is a 360-degree image composed of six cube-face images (top, bottom,
 * left, right, front, back) plus a composite `sourceUrl`. It is linked to a Board
 * via a BoardPanorama join record.
 */
export type Panorama = {
  __typename?: "Panorama";
  /** URL of the back cube face. */
  back: Scalars["String"];
  /** URL of the bottom cube face. */
  bottom: Scalars["String"];
  /** Which library this panorama belongs to. */
  collection?: Maybe<PanoramaCollection>;
  /** URL of the front cube face. */
  front: Scalars["String"];
  /** Primary key. */
  id: Scalars["Int"];
  /** URL of the left cube face. */
  left: Scalars["String"];
  /** Display name of the panorama. */
  name: Scalars["String"];
  /** URL of the right cube face. */
  right: Scalars["String"];
  /** URL of the composite panorama source image. */
  sourceUrl: Scalars["String"];
  /** URL of the top cube face. */
  top: Scalars["String"];
};

/** Identifies which library a Panorama belongs to. */
export enum PanoramaCollection {
  /** A Barnes Foundation curated panorama. */
  BARNES = "BARNES",
  /** A user-uploaded panorama. */
  UPLOADS = "UPLOADS",
}

/**
 * A PresentationVersion is a point-in-time snapshot of a Meeting's board list,
 * captured automatically whenever board content changes while the meeting is recording.
 * The `content` array stores the full ordered board state so that replay can reconstruct
 * exactly what was on screen at any given moment.
 */
export type PresentationVersion = {
  __typename?: "PresentationVersion";
  /** Ordered snapshot of the meeting's boards at the time this version was created. */
  content?: Maybe<Array<Maybe<ReplayBoard>>>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** The Meeting this version belongs to. */
  meeting?: Maybe<Meeting>;
  /** Foreign key of the Meeting this version belongs to. */
  meetingId: Scalars["Int"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
  /** Sequential version number within the meeting, incrementing with each snapshot. */
  versionNumber: Scalars["Int"];
};

/** Request body sent to the recording processing service to concatenate and process a meeting recording. */
export type ProcessRecordingReqBody = {
  __typename?: "ProcessRecordingReqBody";
  /** Chime attendee IDs whose streams are included in the recording. */
  attendeeIds: Array<Scalars["String"]>;
  /** S3 folder path where the concatenated recording will be written. */
  concatFolder: Scalars["String"];
  /** S3 bucket where the concatenated recording will be stored. */
  concatRecordingBucket: Scalars["String"];
  /** If true, the job is running in a local development environment. */
  local?: Maybe<Scalars["Boolean"]>;
  /** Primary key of the MediaPipeline record being processed. */
  mediaPipelineId: Scalars["Int"];
  /** SQS queue URL used to publish status updates during processing. */
  queue: Scalars["String"];
  /** S3 access point ARN used to read the raw recording chunks. */
  recordingAccessPoint: Scalars["String"];
  /** S3 folder path containing the raw recording chunks. */
  recordingFolder: Scalars["String"];
  /** If true, skips the concatenation step and processes the recording directly. */
  skipConcat: Scalars["Boolean"];
  /** ECS task ID assigned to this processing job. */
  taskId: Scalars["String"];
};

/** Processing status for the recording concatenation and processing job on a MediaPipeline. */
export enum ProcessRecordingStatus {
  /** An error occurred during recording processing. */
  ERROR = "ERROR",
  /** An error occurred while initializing the Fargate processing task. */
  ERROR_TASK = "ERROR_TASK",
  /** The pipeline data has been sent to the processing task and is being processed. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The recording was manually updated. Pipelines in this state will skip re-running the job. */
  MANUAL_UPDATE = "MANUAL_UPDATE",
  /** No recording processing action has been taken yet. */
  PENDING = "PENDING",
  /** The pipeline has been queued for recording processing. */
  QUEUED = "QUEUED",
  /** The video used to create HLS files has been replaced and no longer uses the original Chime recording. */
  REPLACED = "REPLACED",
  /** The recording was successfully processed. */
  SUCCESS = "SUCCESS",
}

export type Query = {
  __typename?: "Query";
  /** Return a single feature flag by name, regardless of its active state. */
  checkIsActiveFeature?: Maybe<FeatureFlag>;
  /** Return only feature flags that are currently active. */
  getAllActiveFeatureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** Return all attendee records. */
  getAllAttendees?: Maybe<Array<Maybe<Attendee>>>;
  /** Return all boards across all meetings. */
  getAllBoards?: Maybe<Array<Maybe<Board>>>;
  /** Return all courses. */
  getAllCourses?: Maybe<Array<Maybe<Course>>>;
  /** Return all feature flags regardless of their active state. */
  getAllFeatureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** Return all image uploads across all users. */
  getAllImageUploads?: Maybe<Array<Maybe<ImageUpload>>>;
  /** Return all meetings. */
  getAllMeetings?: Maybe<Array<Maybe<Meeting>>>;
  /** Return all organizations. */
  getAllOrganizations?: Maybe<Array<Maybe<Organization>>>;
  /** Return all panoramas. */
  getAllPanoramas?: Maybe<Array<Maybe<Panorama>>>;
  /** Return all roles. */
  getAllRoles?: Maybe<Array<Maybe<Role>>>;
  /** Return all UserOrganization records. */
  getAllUserOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  /** Return all users. */
  getAllUsers?: Maybe<Array<User>>;
  /** Return all BoardVideo records. */
  getAllVideos?: Maybe<Array<Maybe<BoardVideo>>>;
  /** Return a single attendee by primary key. */
  getAttendee?: Maybe<Attendee>;
  /** Return a single attendee by their Chime external user ID. */
  getAttendeeByExternalId?: Maybe<Attendee>;
  /** Return the current session state. Used by the client to check authentication status on load. */
  getAuthenticatedUser?: Maybe<LoginResponse>;
  /** Return a single board by primary key. */
  getBoard?: Maybe<Board>;
  /** Return a single BoardPanorama by primary key, including its associated Board and Panorama. */
  getBoardPanorama?: Maybe<BoardPanorama>;
  /** Return a single BoardVideo by primary key. */
  getBoardVideo?: Maybe<BoardVideo>;
  /** Return a single course by primary key. */
  getCourse?: Maybe<Course>;
  /** Return a single course by its URL slug. */
  getCourseBySlug?: Maybe<Course>;
  /** Return all meetings for a course, optionally sorted. */
  getCourseMeetings?: Maybe<Array<Maybe<Meeting>>>;
  /** Return courses that have meetings within the given date range and organizations. */
  getCoursesByMeetingDates?: Maybe<Array<Maybe<Course>>>;
  /** Return all image uploads belonging to a specific user. */
  getImageUploadByUserId?: Maybe<Array<Maybe<ImageUpload>>>;
  /** Return a single meeting by primary key. */
  getMeeting?: Maybe<Meeting>;
  /** Return all boards for a meeting, optionally sorted. */
  getMeetingBoards?: Maybe<Array<Maybe<Board>>>;
  /** Return all boards for a meeting looked up by its title, optionally sorted. */
  getMeetingBoardsByMeetingTitle?: Maybe<Array<Maybe<Board>>>;
  /** Return a meeting by its title, optionally filtering to include only the replay pipeline. */
  getMeetingByTitle?: Maybe<Meeting>;
  /** Return a single organization by primary key. */
  getOrganization?: Maybe<Organization>;
  /** Return multiple organizations by their primary keys. */
  getOrganizationsByIds?: Maybe<Array<Maybe<Organization>>>;
  /** Return a single panorama by primary key. */
  getPanorama?: Maybe<Panorama>;
  /** Return a single PresentationVersion by primary key. */
  getPresentationVersion?: Maybe<PresentationVersion>;
  /** Return all PresentationVersions for a meeting, in the order returned by the database. */
  getPresentationVersionsForMeeting?: Maybe<Array<Maybe<PresentationVersion>>>;
  /** Return a meeting by title, configured for replay (equivalent to getMeetingByTitle with replayMeetingPipeline: true). */
  getReplayMeeting?: Maybe<Meeting>;
  /** Return a single role by primary key. */
  getRole?: Maybe<Role>;
  /** Return a single user by primary key. */
  getUser?: Maybe<User>;
  /** Return the UserOrganization record for the currently authenticated user. */
  getUserOrganization?: Maybe<UserOrganization>;
  root?: Maybe<Scalars["String"]>;
  /** Search the art object index. Results are paginated via `paginate` and filtered by the optional `term`. */
  searchArtObjects?: Maybe<Array<Maybe<ArtObject>>>;
  /** Search image uploads by term, with optional organization and permission filters. */
  searchImageUploads?: Maybe<Array<Maybe<ImageUpload>>>;
};

export type QueryCheckIsActiveFeatureArgs = {
  name?: InputMaybe<Scalars["String"]>;
};

export type QueryGetAttendeeArgs = {
  id: Scalars["Int"];
};

export type QueryGetAttendeeByExternalIdArgs = {
  externalId: Scalars["String"];
};

export type QueryGetBoardArgs = {
  id: Scalars["Int"];
};

export type QueryGetBoardPanoramaArgs = {
  id: Scalars["Int"];
};

export type QueryGetBoardVideoArgs = {
  id: Scalars["Int"];
};

export type QueryGetCourseArgs = {
  id: Scalars["Int"];
};

export type QueryGetCourseBySlugArgs = {
  slug: Scalars["String"];
};

export type QueryGetCourseMeetingsArgs = {
  id: Scalars["Int"];
  sortBy?: InputMaybe<SortBy>;
};

export type QueryGetCoursesByMeetingDatesArgs = {
  input?: InputMaybe<DateCourseInput>;
};

export type QueryGetImageUploadByUserIdArgs = {
  userId: Scalars["Int"];
};

export type QueryGetMeetingArgs = {
  id: Scalars["Int"];
};

export type QueryGetMeetingBoardsArgs = {
  meetingId: Scalars["Int"];
  sortBy?: InputMaybe<SortBy>;
};

export type QueryGetMeetingBoardsByMeetingTitleArgs = {
  meetingTitle: Scalars["String"];
  sortBy?: InputMaybe<SortBy>;
};

export type QueryGetMeetingByTitleArgs = {
  replayMeetingPipeline?: InputMaybe<Scalars["Boolean"]>;
  title: Scalars["String"];
};

export type QueryGetOrganizationArgs = {
  id: Scalars["Int"];
};

export type QueryGetOrganizationsByIdsArgs = {
  ids: Array<InputMaybe<Scalars["Int"]>>;
};

export type QueryGetPanoramaArgs = {
  id: Scalars["Int"];
};

export type QueryGetPresentationVersionArgs = {
  id: Scalars["Int"];
};

export type QueryGetPresentationVersionsForMeetingArgs = {
  meetingId: Scalars["Int"];
};

export type QueryGetReplayMeetingArgs = {
  title: Scalars["String"];
};

export type QueryGetRoleArgs = {
  id: Scalars["Int"];
};

export type QueryGetUserArgs = {
  id: Scalars["Int"];
};

export type QuerySearchArtObjectsArgs = {
  paginate?: InputMaybe<Paginate>;
  term?: InputMaybe<Scalars["String"]>;
};

export type QuerySearchImageUploadsArgs = {
  organizationId?: InputMaybe<Scalars["Int"]>;
  paginate?: InputMaybe<Paginate>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  term?: InputMaybe<Scalars["String"]>;
};

/** Result returned by recording-related mutations (`beginRecordMeeting`, `activateMeeting`, `startMediaPipelineConcat`). */
export type RecordMeetingResponse = {
  __typename?: "RecordMeetingResponse";
  /** Error message if the recording could not be started. */
  error?: Maybe<Scalars["String"]>;
  /** Initial presentation version number at the time recording was started. */
  initVersionNumber?: Maybe<Scalars["Int"]>;
  /** The MediaPipeline created or updated for this recording. */
  mediaPipeline?: Maybe<MediaPipeline>;
  /** The Meeting being recorded. */
  meeting?: Maybe<Meeting>;
  /** Status of the recording initialization. */
  status?: Maybe<RecordMeetingStatus>;
  /** Whether the recording was successfully initialized. */
  success?: Maybe<Scalars["Boolean"]>;
};

/** Status of a recording initialization attempt on a Meeting. */
export enum RecordMeetingStatus {
  /** An error occurred while initializing the recording. */
  ERROR = "ERROR",
  /** The recording was already initialized before this request. */
  IN_PROGRESS = "IN_PROGRESS",
  /** The recording was successfully initialized by this request. */
  STARTED = "STARTED",
}

/** Input for the `removeUser` mutation. */
export type RemoveUserInput = {
  /** Primary key of the organization the user is being removed from. */
  id: Scalars["Int"];
  /** Primary key of the UserOrganization join record to remove. */
  userOrgId: Scalars["Int"];
};

/**
 * A read-only snapshot of a Board captured within a PresentationVersion.
 * Association fields use PascalCase to match the Sequelize eager-load output
 * stored in the version's content payload.
 */
export type ReplayBoard = {
  __typename?: "ReplayBoard";
  /** IIIF image assets linked to this board at the time of the snapshot. */
  BoardImages?: Maybe<Array<Maybe<ReplayBoardImage>>>;
  /** Panorama asset linked to this board at the time of the snapshot. */
  BoardPanorama?: Maybe<BoardPanoramaReplay>;
  /** 3D model asset linked to this board at the time of the snapshot. */
  BoardThreedee?: Maybe<BoardThreedee>;
  /** Video asset linked to this board at the time of the snapshot. */
  BoardVideo?: Maybe<BoardVideo>;
  /** Caption of the board at the time of the snapshot. */
  caption?: Maybe<Scalars["String"]>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** The parent Meeting. */
  meeting?: Maybe<Meeting>;
  /** Foreign key of the parent Meeting. */
  meetingId?: Maybe<Scalars["Int"]>;
  /** Position of the board within the meeting's slide list at the time of the snapshot. */
  sortOrder?: Maybe<Scalars["Int"]>;
  /** Display title of the board at the time of the snapshot. */
  title?: Maybe<Scalars["String"]>;
  /** Content type of the board at the time of the snapshot. */
  type?: Maybe<BoardType>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/**
 * A read-only snapshot of a BoardImage captured within a PresentationVersion.
 * Field names follow the Sequelize association casing returned at snapshot time.
 */
export type ReplayBoardImage = {
  __typename?: "ReplayBoardImage";
  /** The linked ImageUpload record, if present. */
  ImageUpload?: Maybe<ImageUpload>;
  /** The parent Board. */
  board?: Maybe<Board>;
  /** Foreign key of the parent Board. */
  boardId?: Maybe<Scalars["Int"]>;
  /** Linked image layers, if present. */
  boardImageLayers?: Maybe<Array<Maybe<BoardImageLayer>>>;
  /** Display height of the image within the viewer layout. */
  height?: Maybe<Scalars["Int"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Foreign key of the linked ImageUpload record, if applicable. */
  imageUploadId?: Maybe<Scalars["Int"]>;
  /** IIIF tile source URL for the image. */
  tileSource?: Maybe<Scalars["String"]>;
  /** Display width of the image within the viewer layout. */
  width?: Maybe<Scalars["Int"]>;
  /** Horizontal position of the image within the viewer layout. */
  x?: Maybe<Scalars["Int"]>;
  /** Vertical position of the image within the viewer layout. */
  y?: Maybe<Scalars["Int"]>;
};

/**
 * A Role defines the permission set granted to a user within an organization.
 * The boolean capability flags are checked by resolver authorization logic to
 * determine what actions the user can perform.
 */
export type Role = {
  __typename?: "Role";
  /** Whether users with this role can create demo meetings. */
  canCreateDemoMeeting?: Maybe<Scalars["Boolean"]>;
  /** Whether users with this role can log in to the platform. */
  canLogin?: Maybe<Scalars["Boolean"]>;
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Soft-deletion timestamp (Unix ms). Null if the role has not been deleted. */
  deletedAt?: Maybe<Scalars["Float"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** Whether this role appears in organization management UIs. */
  isVisible: Scalars["Boolean"];
  /** Display name of the role. */
  name: Scalars["String"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
};

/** Role names used within the platform. */
export enum Roles {
  /** Full administrative access within an organization. */
  Admin = "Admin",
  /** Limited access for demo or guest users. */
  Demo = "Demo",
  /** Access has been explicitly revoked. The user cannot log in. */
  Revoked = "Revoked",
  /** Standard student access for meeting attendees. */
  Student = "Student",
}

/** Session cookie metadata returned as part of the active session. */
export type SessionCookie = {
  __typename?: "SessionCookie";
  /** Maximum age of the session cookie in milliseconds. */
  maxAge?: Maybe<Scalars["Int"]>;
};

/**
 * The current session state for the authenticated user.
 * Returned by `getAuthenticatedUser` and used server-side to gate resolver access.
 */
export type SessionObject = {
  __typename?: "SessionObject";
  /** Primary key of the attendee record, if the session is for a meeting attendee. */
  attendeeId?: Maybe<Scalars["Int"]>;
  /** Session cookie metadata. */
  cookie?: Maybe<SessionCookie>;
  /** Whether the session has been initialized. */
  initialized: Scalars["Boolean"];
  /** Whether the user is currently authenticated. */
  isAuthenticated: Scalars["Boolean"];
  /** List of organization IDs the user belongs to. */
  organizationIds?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  /** Organization-scoped permissions for the session user. */
  permissions?: Maybe<Array<Maybe<SessionPermission>>>;
  /** Primary key of the authenticated user, if logged in. */
  userId?: Maybe<Scalars["Int"]>;
};

/** A single organization-scoped permission entry attached to the active session. */
export type SessionPermission = {
  __typename?: "SessionPermission";
  /** The organization this permission applies to. */
  organizationId?: Maybe<Scalars["Int"]>;
  /** The role granted to the user within that organization. */
  role?: Maybe<Role>;
};

/** Input for the `setReplayRecordingPipeline` mutation. */
export type SetReplayRecordingPipelineInput = {
  /** Primary key of the Meeting to update. */
  id: Scalars["Int"];
  /** Primary key of the MediaPipeline to designate as the replay recording. Clears the selection if omitted. */
  mediaPipelineId?: InputMaybe<Scalars["Int"]>;
};

export type SortBy = {
  field: Scalars["String"];
  order: Order;
};

/** Input for `startAndJoinMeeting` and `startFhdMeeting`, providing the joining user's identity. */
export type StartAndJoinMeetingInput = {
  /** Device and browser information captured at join time. */
  deviceInfo?: InputMaybe<DeviceInfoInput>;
  /** First name of the user joining the meeting. */
  firstName: Scalars["String"];
  /** Last name of the user joining the meeting. */
  lastName: Scalars["String"];
  /** Numeric role for the user within the meeting. */
  userRole?: InputMaybe<Scalars["Int"]>;
};

/** Result returned by `startAndJoinMeeting` and `startFhdMeeting`. */
export type StartMeetingResponse = {
  __typename?: "StartMeetingResponse";
  /** The Attendee record created for the joining user. */
  attendee?: Maybe<Attendee>;
  /** Error message if the meeting could not be started. */
  error?: Maybe<Scalars["String"]>;
  /** Initial presentation version number at the time the meeting was started. */
  initVersionNumber?: Maybe<Scalars["Int"]>;
  /** The started Meeting. */
  meeting?: Maybe<Meeting>;
  /** Status of the recording initialization, if recording was started alongside the meeting. */
  recordMeetingStatus?: Maybe<RecordMeetingStatus>;
  /** Whether the meeting was successfully started. */
  startMeetingSuccess?: Maybe<Scalars["Boolean"]>;
};

export type TableStringFilterInput = {
  beginsWith?: InputMaybe<Scalars["String"]>;
  between?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  contains?: InputMaybe<Scalars["String"]>;
  eq?: InputMaybe<Scalars["String"]>;
  ge?: InputMaybe<Scalars["String"]>;
  gt?: InputMaybe<Scalars["String"]>;
  le?: InputMaybe<Scalars["String"]>;
  lt?: InputMaybe<Scalars["String"]>;
  ne?: InputMaybe<Scalars["String"]>;
  notContains?: InputMaybe<Scalars["String"]>;
};

/** Processing status of the thumbnail generation for an uploaded image. */
export enum ThumbnailConversionStatus {
  /** An error occurred during thumbnail generation. Images in this state will be retried. */
  ERROR = "ERROR",
  /** The image data has been sent to the thumbnail generation service and is being processed. */
  IN_PROGRESS = "IN_PROGRESS",
  /** No thumbnail generation action has been taken yet. */
  PENDING = "PENDING",
  /** The image has been queued for thumbnail generation. */
  QUEUED = "QUEUED",
  /** The thumbnail was successfully generated. */
  SUCCESS = "SUCCESS",
}

/** Result returned by the `createBoardImages` mutation. */
export type UpdateBoardImageResponse = {
  __typename?: "UpdateBoardImageResponse";
  /** The full updated set of board images for the board, sorted by ascending ID. */
  boardImages?: Maybe<Array<Maybe<BoardImage>>>;
  /** New presentation version number, if the meeting was recording when the images were added. */
  currentVersion?: Maybe<Scalars["Int"]>;
};

/** Result returned by the `createBoardPanorama` mutation. */
export type UpdateBoardPanoramaResponse = {
  __typename?: "UpdateBoardPanoramaResponse";
  /** The created or updated BoardPanorama record. */
  boardPanorama?: Maybe<BoardPanorama>;
  /** New presentation version number, if the meeting was recording when the change was made. */
  currentVersion?: Maybe<Scalars["Int"]>;
};

/** Result returned by board create, edit, and duplicate mutations. */
export type UpdateBoardResponse = {
  __typename?: "UpdateBoardResponse";
  /** The created or updated board. */
  board?: Maybe<Board>;
  /** New presentation version number, if the meeting was recording when the change was made. */
  currentVersion?: Maybe<Scalars["Int"]>;
};

/** Result returned by the `createBoardThreedee` mutation. */
export type UpdateBoardThreedeeResponse = {
  __typename?: "UpdateBoardThreedeeResponse";
  /** The created BoardThreedee record. */
  boardThreedee?: Maybe<BoardThreedee>;
  /** New presentation version number, if the meeting was recording when the record was created. */
  currentVersion?: Maybe<Scalars["Int"]>;
};

/** Result returned by the `createBoardVideo` mutation. */
export type UpdateBoardVideoResponse = {
  __typename?: "UpdateBoardVideoResponse";
  /** The created or updated BoardVideo record. */
  boardVideo?: Maybe<BoardVideo>;
  /** New presentation version number, if the meeting was recording when the change was made. */
  currentVersion?: Maybe<Scalars["Int"]>;
};

/** Input for updating a user's role within an organization. */
export type UpdateUserOrgInput = {
  /** Primary key of the UserOrganization record to update. */
  id: Scalars["Int"];
  /** Foreign key of the new Role to assign. */
  roleId: Scalars["Int"];
  /** Primary key of the user whose role is being updated. */
  userId: Scalars["Int"];
};

/** Input for the `updateUsers` mutation. */
export type UpdateUsersInput = {
  /** Primary key of the organization to update. */
  id: Scalars["Int"];
  /** Updated UserOrganization records for all users in the organization. */
  userOrgs: Array<InputMaybe<UpdateUserOrgInput>>;
};

/**
 * A registered platform user. Users belong to one or more Organizations via
 * UserOrganization join records, each carrying a Role that controls their access
 * within that organization.
 */
export type User = {
  __typename?: "User";
  /** Creation timestamp (Unix ms). */
  createdAt?: Maybe<Scalars["Float"]>;
  /** User's email address, used as their login identifier. */
  email?: Maybe<Scalars["String"]>;
  /** User's first name. */
  firstName?: Maybe<Scalars["String"]>;
  /** Primary key. */
  id: Scalars["Int"];
  /** User's last name. */
  lastName?: Maybe<Scalars["String"]>;
  /** Organizations this user belongs to. */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  /** Last-updated timestamp (Unix ms). */
  updatedAt?: Maybe<Scalars["Float"]>;
  /** Organization memberships with their associated roles. */
  userOrganizations?: Maybe<Array<Maybe<UserOrgWithRole>>>;
};

/** A flattened view of a UserOrganization used in user-facing queries, including the resolved role. */
export type UserOrgWithRole = {
  __typename?: "UserOrgWithRole";
  /** Primary key of the UserOrganization record. */
  id?: Maybe<Scalars["Int"]>;
  /** The Organization this membership belongs to. */
  organization?: Maybe<Organization>;
  /** Foreign key of the Organization. */
  organizationId?: Maybe<Scalars["Int"]>;
  /** The Role granted to the user within this organization. */
  role?: Maybe<Role>;
  /** Foreign key of the User. */
  userID?: Maybe<Scalars["Int"]>;
};

/**
 * A UserOrganization is the join record linking a User to an Organization with a
 * specific Role. It represents a user's membership within an organization and controls
 * what they are permitted to do within it.
 */
export type UserOrganization = {
  __typename?: "UserOrganization";
  /** Creation timestamp (Unix ms). */
  createdAt: Scalars["Float"];
  /** Primary key. */
  id: Scalars["Int"];
  /** The Organization this membership belongs to. */
  organization?: Maybe<Organization>;
  /** Foreign key of the Organization. */
  organizationId: Scalars["Int"];
  /** The Role granted to the user within this organization. */
  role?: Maybe<Role>;
  /** Foreign key of the Role granted to the user within this organization. */
  roleId: Scalars["Int"];
  /** Last-updated timestamp (Unix ms). */
  updatedAt: Scalars["Float"];
  /** The User this membership belongs to. */
  user?: Maybe<User>;
  /** Foreign key of the User. */
  userId: Scalars["Int"];
};

/** Result returned by the `toggleMuteLock` mutation. */
export type MuteLockResponse = {
  __typename?: "muteLockResponse";
  /** Error message if the toggle failed. */
  error?: Maybe<Scalars["String"]>;
  /** The updated Meeting. */
  meeting?: Maybe<Meeting>;
};

/** Result returned by the `toggleVideoOffLock` mutation. */
export type VideoOffLockResponse = {
  __typename?: "videoOffLockResponse";
  /** Error message if the toggle failed. */
  error?: Maybe<Scalars["String"]>;
  /** The updated Meeting. */
  meeting?: Maybe<Meeting>;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {}
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AddUserInput: AddUserInput;
  ArtObject: ResolverTypeWrapper<ArtObject>;
  Attendee: ResolverTypeWrapper<Attendee>;
  Board: ResolverTypeWrapper<Board>;
  BoardImage: ResolverTypeWrapper<BoardImage>;
  BoardImageLayer: ResolverTypeWrapper<BoardImageLayer>;
  BoardPanorama: ResolverTypeWrapper<BoardPanorama>;
  BoardPanoramaReplay: ResolverTypeWrapper<BoardPanoramaReplay>;
  BoardThreedee: ResolverTypeWrapper<BoardThreedee>;
  BoardType: BoardType;
  BoardVideo: ResolverTypeWrapper<BoardVideo>;
  Boolean: ResolverTypeWrapper<Scalars["Boolean"]>;
  ChapterPreviewType: ChapterPreviewType;
  Course: ResolverTypeWrapper<Course>;
  CreateAttendeeInput: CreateAttendeeInput;
  CreateBoardImage: CreateBoardImage;
  CreateBoardImageLayer: CreateBoardImageLayer;
  CreateBoardInput: CreateBoardInput;
  CreateBoardPanorama: CreateBoardPanorama;
  CreateBoardThreedee: CreateBoardThreedee;
  CreateBoardVideoInput: CreateBoardVideoInput;
  CreateCourseInput: CreateCourseInput;
  CreateDemoMeetingInput: CreateDemoMeetingInput;
  CreateDemoMeetingResponse: ResolverTypeWrapper<CreateDemoMeetingResponse>;
  CreateImageUploadInput: CreateImageUploadInput;
  CreateMeetingInput: CreateMeetingInput;
  CreateOrgInput: CreateOrgInput;
  CreatePanorama: CreatePanorama;
  CreateUserInput: CreateUserInput;
  CreateUserOrgInput: CreateUserOrgInput;
  CreateUserResponse: ResolverTypeWrapper<CreateUserResponse>;
  DataProcessor: DataProcessor;
  DateCourseInput: DateCourseInput;
  DeleteBoardInput: DeleteBoardInput;
  DeleteChimeAttendeeResponse: ResolverTypeWrapper<DeleteChimeAttendeeResponse>;
  DeleteMeetingResponse: ResolverTypeWrapper<DeleteMeetingResponse>;
  DeletedBoard: ResolverTypeWrapper<DeletedBoard>;
  DeletedBoardImage: ResolverTypeWrapper<DeletedBoardImage>;
  DeletedCourse: ResolverTypeWrapper<DeletedCourse>;
  DeviceInfo: ResolverTypeWrapper<DeviceInfo>;
  DeviceInfoInput: DeviceInfoInput;
  DuplicateBoardInput: DuplicateBoardInput;
  DuplicateCourseInput: DuplicateCourseInput;
  DuplicateMeetingInput: DuplicateMeetingInput;
  EditBoardInput: EditBoardInput;
  EditCourseInput: EditCourseInput;
  EndMeetingInput: EndMeetingInput;
  EndMeetingResponse: ResolverTypeWrapper<EndMeetingResponse>;
  FeatureFlag: ResolverTypeWrapper<FeatureFlag>;
  FeatureFlagType: FeatureFlagType;
  Float: ResolverTypeWrapper<Scalars["Float"]>;
  GenerateVTTStatus: GenerateVttStatus;
  IconColor: IconColor;
  IiiFConversionStatus: IiiFConversionStatus;
  IiifConversionReqBody: ResolverTypeWrapper<IiifConversionReqBody>;
  IiifConversionResponse: ResolverTypeWrapper<IiifConversionResponse>;
  ImageUpload: ResolverTypeWrapper<ImageUpload>;
  Int: ResolverTypeWrapper<Scalars["Int"]>;
  JSON: ResolverTypeWrapper<Scalars["JSON"]>;
  Job: ResolverTypeWrapper<Job>;
  JobName: JobName;
  JobResponse: ResolverTypeWrapper<JobResponse>;
  LoginInput: LoginInput;
  LoginResponse: ResolverTypeWrapper<LoginResponse>;
  LogoutInput: LogoutInput;
  LogoutResponse: ResolverTypeWrapper<LogoutResponse>;
  MediaPipeline: ResolverTypeWrapper<MediaPipeline>;
  Meeting: ResolverTypeWrapper<Meeting>;
  MeetingError: ResolverTypeWrapper<MeetingError>;
  MeetingErrorCodes: MeetingErrorCodes;
  MetaDataPermissions: MetaDataPermissions;
  Mutation: ResolverTypeWrapper<{}>;
  Order: Order;
  Organization: ResolverTypeWrapper<Organization>;
  Paginate: Paginate;
  Panorama: ResolverTypeWrapper<Panorama>;
  PanoramaCollection: PanoramaCollection;
  PresentationVersion: ResolverTypeWrapper<PresentationVersion>;
  ProcessRecordingReqBody: ResolverTypeWrapper<ProcessRecordingReqBody>;
  ProcessRecordingStatus: ProcessRecordingStatus;
  Query: ResolverTypeWrapper<{}>;
  RecordMeetingResponse: ResolverTypeWrapper<RecordMeetingResponse>;
  RecordMeetingStatus: RecordMeetingStatus;
  RemoveUserInput: RemoveUserInput;
  ReplayBoard: ResolverTypeWrapper<ReplayBoard>;
  ReplayBoardImage: ResolverTypeWrapper<ReplayBoardImage>;
  Role: ResolverTypeWrapper<Role>;
  Roles: Roles;
  SessionCookie: ResolverTypeWrapper<SessionCookie>;
  SessionObject: ResolverTypeWrapper<SessionObject>;
  SessionPermission: ResolverTypeWrapper<SessionPermission>;
  SetReplayRecordingPipelineInput: SetReplayRecordingPipelineInput;
  SortBy: SortBy;
  StartAndJoinMeetingInput: StartAndJoinMeetingInput;
  StartMeetingResponse: ResolverTypeWrapper<StartMeetingResponse>;
  String: ResolverTypeWrapper<Scalars["String"]>;
  TableStringFilterInput: TableStringFilterInput;
  ThumbnailConversionStatus: ThumbnailConversionStatus;
  UpdateBoardImageResponse: ResolverTypeWrapper<UpdateBoardImageResponse>;
  UpdateBoardPanoramaResponse: ResolverTypeWrapper<UpdateBoardPanoramaResponse>;
  UpdateBoardResponse: ResolverTypeWrapper<UpdateBoardResponse>;
  UpdateBoardThreedeeResponse: ResolverTypeWrapper<UpdateBoardThreedeeResponse>;
  UpdateBoardVideoResponse: ResolverTypeWrapper<UpdateBoardVideoResponse>;
  UpdateUserOrgInput: UpdateUserOrgInput;
  UpdateUsersInput: UpdateUsersInput;
  User: ResolverTypeWrapper<User>;
  UserOrgWithRole: ResolverTypeWrapper<UserOrgWithRole>;
  UserOrganization: ResolverTypeWrapper<UserOrganization>;
  muteLockResponse: ResolverTypeWrapper<MuteLockResponse>;
  videoOffLockResponse: ResolverTypeWrapper<VideoOffLockResponse>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AddUserInput: AddUserInput;
  ArtObject: ArtObject;
  Attendee: Attendee;
  Board: Board;
  BoardImage: BoardImage;
  BoardImageLayer: BoardImageLayer;
  BoardPanorama: BoardPanorama;
  BoardPanoramaReplay: BoardPanoramaReplay;
  BoardThreedee: BoardThreedee;
  BoardVideo: BoardVideo;
  Boolean: Scalars["Boolean"];
  Course: Course;
  CreateAttendeeInput: CreateAttendeeInput;
  CreateBoardImage: CreateBoardImage;
  CreateBoardImageLayer: CreateBoardImageLayer;
  CreateBoardInput: CreateBoardInput;
  CreateBoardPanorama: CreateBoardPanorama;
  CreateBoardThreedee: CreateBoardThreedee;
  CreateBoardVideoInput: CreateBoardVideoInput;
  CreateCourseInput: CreateCourseInput;
  CreateDemoMeetingInput: CreateDemoMeetingInput;
  CreateDemoMeetingResponse: CreateDemoMeetingResponse;
  CreateImageUploadInput: CreateImageUploadInput;
  CreateMeetingInput: CreateMeetingInput;
  CreateOrgInput: CreateOrgInput;
  CreatePanorama: CreatePanorama;
  CreateUserInput: CreateUserInput;
  CreateUserOrgInput: CreateUserOrgInput;
  CreateUserResponse: CreateUserResponse;
  DateCourseInput: DateCourseInput;
  DeleteBoardInput: DeleteBoardInput;
  DeleteChimeAttendeeResponse: DeleteChimeAttendeeResponse;
  DeleteMeetingResponse: DeleteMeetingResponse;
  DeletedBoard: DeletedBoard;
  DeletedBoardImage: DeletedBoardImage;
  DeletedCourse: DeletedCourse;
  DeviceInfo: DeviceInfo;
  DeviceInfoInput: DeviceInfoInput;
  DuplicateBoardInput: DuplicateBoardInput;
  DuplicateCourseInput: DuplicateCourseInput;
  DuplicateMeetingInput: DuplicateMeetingInput;
  EditBoardInput: EditBoardInput;
  EditCourseInput: EditCourseInput;
  EndMeetingInput: EndMeetingInput;
  EndMeetingResponse: EndMeetingResponse;
  FeatureFlag: FeatureFlag;
  Float: Scalars["Float"];
  IiifConversionReqBody: IiifConversionReqBody;
  IiifConversionResponse: IiifConversionResponse;
  ImageUpload: ImageUpload;
  Int: Scalars["Int"];
  JSON: Scalars["JSON"];
  Job: Job;
  JobResponse: JobResponse;
  LoginInput: LoginInput;
  LoginResponse: LoginResponse;
  LogoutInput: LogoutInput;
  LogoutResponse: LogoutResponse;
  MediaPipeline: MediaPipeline;
  Meeting: Meeting;
  MeetingError: MeetingError;
  Mutation: {};
  Organization: Organization;
  Paginate: Paginate;
  Panorama: Panorama;
  PresentationVersion: PresentationVersion;
  ProcessRecordingReqBody: ProcessRecordingReqBody;
  Query: {};
  RecordMeetingResponse: RecordMeetingResponse;
  RemoveUserInput: RemoveUserInput;
  ReplayBoard: ReplayBoard;
  ReplayBoardImage: ReplayBoardImage;
  Role: Role;
  SessionCookie: SessionCookie;
  SessionObject: SessionObject;
  SessionPermission: SessionPermission;
  SetReplayRecordingPipelineInput: SetReplayRecordingPipelineInput;
  SortBy: SortBy;
  StartAndJoinMeetingInput: StartAndJoinMeetingInput;
  StartMeetingResponse: StartMeetingResponse;
  String: Scalars["String"];
  TableStringFilterInput: TableStringFilterInput;
  UpdateBoardImageResponse: UpdateBoardImageResponse;
  UpdateBoardPanoramaResponse: UpdateBoardPanoramaResponse;
  UpdateBoardResponse: UpdateBoardResponse;
  UpdateBoardThreedeeResponse: UpdateBoardThreedeeResponse;
  UpdateBoardVideoResponse: UpdateBoardVideoResponse;
  UpdateUserOrgInput: UpdateUserOrgInput;
  UpdateUsersInput: UpdateUsersInput;
  User: User;
  UserOrgWithRole: UserOrgWithRole;
  UserOrganization: UserOrganization;
  muteLockResponse: MuteLockResponse;
  videoOffLockResponse: VideoOffLockResponse;
};

export type ArtObjectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["ArtObject"] = ResolversParentTypes["ArtObject"]
> = {
  artistPrefix?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  artistSuffix?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  bibliography?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  birthDate?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  creditLine?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  culture?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  curatorialApproval?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deathDate?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  dimensions?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  displayDate?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ensembleIndex?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  exhHistory?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  imageOriginalSecret?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  imageSecret?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  invno?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  longDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  medium?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  nationality?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  objRightsTypeId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  onview?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  people?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  publishedProvenance?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  shortDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Attendee"] = ResolversParentTypes["Attendee"]
> = {
  AttendeeId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ExternalUserId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  JoinToken?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  deviceInfo?: Resolver<
    Maybe<ResolversTypes["DeviceInfo"]>,
    ParentType,
    ContextType
  >;
  firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  iconColor?: Resolver<
    Maybe<ResolversTypes["IconColor"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  meetingId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  meetingRole?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  softBanned?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Board"] = ResolversParentTypes["Board"]
> = {
  boardImages?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["BoardImage"]>>>,
    ParentType,
    ContextType
  >;
  boardPanorama?: Resolver<
    Maybe<ResolversTypes["BoardPanorama"]>,
    ParentType,
    ContextType
  >;
  boardThreedee?: Resolver<
    Maybe<ResolversTypes["BoardThreedee"]>,
    ParentType,
    ContextType
  >;
  boardVideo?: Resolver<
    Maybe<ResolversTypes["BoardVideo"]>,
    ParentType,
    ContextType
  >;
  caption?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  meetingId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes["BoardType"]>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardImage"] = ResolversParentTypes["BoardImage"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  boardImageLayers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["BoardImageLayer"]>>>,
    ParentType,
    ContextType
  >;
  height?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  imageUpload?: Resolver<
    Maybe<ResolversTypes["ImageUpload"]>,
    ParentType,
    ContextType
  >;
  imageUploadId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tileSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardImageLayerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardImageLayer"] = ResolversParentTypes["BoardImageLayer"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  boardImage?: Resolver<
    Maybe<ResolversTypes["BoardImage"]>,
    ParentType,
    ContextType
  >;
  boardImageId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  height?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  imageUpload?: Resolver<
    Maybe<ResolversTypes["ImageUpload"]>,
    ParentType,
    ContextType
  >;
  imageUploadId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tileSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardPanoramaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardPanorama"] = ResolversParentTypes["BoardPanorama"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  panorama?: Resolver<
    Maybe<ResolversTypes["Panorama"]>,
    ParentType,
    ContextType
  >;
  panoramaId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardPanoramaReplayResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardPanoramaReplay"] = ResolversParentTypes["BoardPanoramaReplay"]
> = {
  Panorama?: Resolver<
    Maybe<ResolversTypes["Panorama"]>,
    ParentType,
    ContextType
  >;
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  panoramaId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardThreedeeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardThreedee"] = ResolversParentTypes["BoardThreedee"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  sourceUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardVideoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["BoardVideo"] = ResolversParentTypes["BoardVideo"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sourceUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Course"] = ResolversParentTypes["Course"]
> = {
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  meetings?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Meeting"]>>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType
  >;
  organizationId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDemoMeetingResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["CreateDemoMeetingResponse"] = ResolversParentTypes["CreateDemoMeetingResponse"]
> = {
  attendee?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType
  >;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["CreateUserResponse"] = ResolversParentTypes["CreateUserResponse"]
> = {
  createdAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteChimeAttendeeResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeleteChimeAttendeeResponse"] = ResolversParentTypes["DeleteChimeAttendeeResponse"]
> = {
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteMeetingResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeleteMeetingResponse"] = ResolversParentTypes["DeleteMeetingResponse"]
> = {
  course?: Resolver<Maybe<ResolversTypes["Course"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedBoardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeletedBoard"] = ResolversParentTypes["DeletedBoard"]
> = {
  boardError?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  boardImagesError?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  boardPanoramaError?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  boardVideoError?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedBoardImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeletedBoardImage"] = ResolversParentTypes["DeletedBoardImage"]
> = {
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedCourseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeletedCourse"] = ResolversParentTypes["DeletedCourse"]
> = {
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["DeviceInfo"] = ResolversParentTypes["DeviceInfo"]
> = {
  browserName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  browserVersion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deviceModel?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deviceType?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deviceVendor?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  engine?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  os?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  osVersion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  userAgent?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EndMeetingResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["EndMeetingResponse"] = ResolversParentTypes["EndMeetingResponse"]
> = {
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["FeatureFlag"] = ResolversParentTypes["FeatureFlag"]
> = {
  active?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IiifConversionReqBodyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["IiifConversionReqBody"] = ResolversParentTypes["IiifConversionReqBody"]
> = {
  outputBucket?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  outputName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  sourceURL?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IiifConversionResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["IiifConversionResponse"] = ResolversParentTypes["IiifConversionResponse"]
> = {
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tileOutputPath?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageUploadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["ImageUpload"] = ResolversParentTypes["ImageUpload"]
> = {
  birthDate?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  classification?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  creditLine?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  culture?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  deathDate?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  dimensions?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  displayDate?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  iiifConversionStatus?: Resolver<
    Maybe<ResolversTypes["IiiFConversionStatus"]>,
    ParentType,
    ContextType
  >;
  medium?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  nationality?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  organizationId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  people?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  permissions?: Resolver<
    Maybe<ResolversTypes["MetaDataPermissions"]>,
    ParentType,
    ContextType
  >;
  thumbnailConversionStatus?: Resolver<
    Maybe<ResolversTypes["ThumbnailConversionStatus"]>,
    ParentType,
    ContextType
  >;
  thumbnailUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  tileSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  visualDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["JSON"], any> {
  name: "JSON";
}

export type JobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Job"] = ResolversParentTypes["Job"]
> = {
  concatPipelineId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  force?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes["JobName"], ParentType, ContextType>;
  skipConcat?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  videoLength?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["JobResponse"] = ResolversParentTypes["JobResponse"]
> = {
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["LoginResponse"] = ResolversParentTypes["LoginResponse"]
> = {
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  firstName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  isAuthenticated?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  lastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["UserOrgWithRole"]>>>,
    ParentType,
    ContextType
  >;
  permissions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["SessionPermission"]>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["LogoutResponse"] = ResolversParentTypes["LogoutResponse"]
> = {
  firstName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  isAuthenticated?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  lastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaPipelineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["MediaPipeline"] = ResolversParentTypes["MediaPipeline"]
> = {
  arn?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  attendeeLogStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  awsConcatPipelineId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsPipelineId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  chatLogStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  dataProcessor?: Resolver<
    ResolversTypes["DataProcessor"],
    ParentType,
    ContextType
  >;
  folderName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  generateCaptionsStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  generateChaptersStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  generateChatStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  generateEventsStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  presentationLogStatus?: Resolver<
    ResolversTypes["GenerateVTTStatus"],
    ParentType,
    ContextType
  >;
  processRecordingStatus?: Resolver<
    ResolversTypes["ProcessRecordingStatus"],
    ParentType,
    ContextType
  >;
  replayRecording?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  videoLength?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Meeting"] = ResolversParentTypes["Meeting"]
> = {
  AudioFallbackUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  AudioHostUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  EventIngestionUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ExternalMeetingId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  MediaPipelines?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["MediaPipeline"]>>>,
    ParentType,
    ContextType
  >;
  MediaRegion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  MeetingArn?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  MeetingId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ScreenDataUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ScreenSharingUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  ScreenViewingUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  SignalingUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  TurnControlUrl?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  attendees?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Attendee"]>>>,
    ParentType,
    ContextType
  >;
  boards?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Board"]>>>,
    ParentType,
    ContextType
  >;
  chat?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  course?: Resolver<Maybe<ResolversTypes["Course"]>, ParentType, ContextType>;
  courseId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  currentlyRecording?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  deletedAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  instructorAV?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  lobbyActive?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  mediaPipelines?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["MediaPipeline"]>>>,
    ParentType,
    ContextType
  >;
  meetingTime?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  muteLock?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  presentationVersions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["PresentationVersion"]>>>,
    ParentType,
    ContextType
  >;
  studentAV?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  title?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  videoOffLock?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["MeetingError"] = ResolversParentTypes["MeetingError"]
> = {
  code?: Resolver<ResolversTypes["MeetingErrorCodes"], ParentType, ContextType>;
  message?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Mutation"] = ResolversParentTypes["Mutation"]
> = {
  activateMeeting?: Resolver<
    Maybe<ResolversTypes["RecordMeetingResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationActivateMeetingArgs, "id">
  >;
  addUsers?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    Partial<MutationAddUsersArgs>
  >;
  attendeeLeaveMeeting?: Resolver<
    Maybe<ResolversTypes["DeleteChimeAttendeeResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationAttendeeLeaveMeetingArgs>
  >;
  beginRecordMeeting?: Resolver<
    Maybe<ResolversTypes["RecordMeetingResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationBeginRecordMeetingArgs, "id">
  >;
  bulkCreateImageUploads?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType,
    Partial<MutationBulkCreateImageUploadsArgs>
  >;
  createAndStartMeeting?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateAndStartMeetingArgs>
  >;
  createAttendee?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateAttendeeArgs>
  >;
  createBoard?: Resolver<
    Maybe<ResolversTypes["UpdateBoardResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateBoardArgs>
  >;
  createBoardImages?: Resolver<
    Maybe<ResolversTypes["UpdateBoardImageResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateBoardImagesArgs>
  >;
  createBoardPanorama?: Resolver<
    Maybe<ResolversTypes["UpdateBoardPanoramaResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateBoardPanoramaArgs>
  >;
  createBoardThreedee?: Resolver<
    Maybe<ResolversTypes["UpdateBoardThreedeeResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateBoardThreedeeArgs>
  >;
  createBoardVideo?: Resolver<
    Maybe<ResolversTypes["UpdateBoardVideoResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateBoardVideoArgs>
  >;
  createCourse?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateCourseArgs>
  >;
  createDemoMeeting?: Resolver<
    Maybe<ResolversTypes["CreateDemoMeetingResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateDemoMeetingArgs>
  >;
  createMeeting?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateMeetingArgs>
  >;
  createOrganization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateOrganizationArgs>
  >;
  createPanorama?: Resolver<
    Maybe<ResolversTypes["Panorama"]>,
    ParentType,
    ContextType,
    Partial<MutationCreatePanoramaArgs>
  >;
  createUser?: Resolver<
    Maybe<ResolversTypes["CreateUserResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationCreateUserArgs>
  >;
  deleteBoard?: Resolver<
    Maybe<ResolversTypes["DeletedBoard"]>,
    ParentType,
    ContextType,
    Partial<MutationDeleteBoardArgs>
  >;
  deleteBoardImage?: Resolver<
    Maybe<ResolversTypes["DeletedBoardImage"]>,
    ParentType,
    ContextType,
    Partial<MutationDeleteBoardImageArgs>
  >;
  deleteCourse?: Resolver<
    Maybe<ResolversTypes["DeletedCourse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCourseArgs, "id">
  >;
  deleteMeeting?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    Partial<MutationDeleteMeetingArgs>
  >;
  duplicateBoard?: Resolver<
    Maybe<ResolversTypes["UpdateBoardResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationDuplicateBoardArgs>
  >;
  duplicateCourse?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    Partial<MutationDuplicateCourseArgs>
  >;
  duplicateMeeting?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    Partial<MutationDuplicateMeetingArgs>
  >;
  editBoard?: Resolver<
    Maybe<ResolversTypes["UpdateBoardResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationEditBoardArgs>
  >;
  editCourse?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    Partial<MutationEditCourseArgs>
  >;
  editMeeting?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    Partial<MutationEditMeetingArgs>
  >;
  endMeeting?: Resolver<
    Maybe<ResolversTypes["EndMeetingResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationEndMeetingArgs>
  >;
  login?: Resolver<
    Maybe<ResolversTypes["LoginResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationLoginArgs>
  >;
  logout?: Resolver<
    Maybe<ResolversTypes["LogoutResponse"]>,
    ParentType,
    ContextType,
    Partial<MutationLogoutArgs>
  >;
  removeUser?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    Partial<MutationRemoveUserArgs>
  >;
  replaceMeetingRecording?: Resolver<
    Maybe<ResolversTypes["MediaPipeline"]>,
    ParentType,
    ContextType,
    RequireFields<MutationReplaceMeetingRecordingArgs, "id">
  >;
  root?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  setReplayRecordingPipeline?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    Partial<MutationSetReplayRecordingPipelineArgs>
  >;
  softBanAttendee?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType,
    RequireFields<MutationSoftBanAttendeeArgs, "AttendeeId" | "softBan">
  >;
  startAndJoinMeeting?: Resolver<
    Maybe<ResolversTypes["StartMeetingResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationStartAndJoinMeetingArgs, "id" | "input">
  >;
  startBulkGenerateVttFiles?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["MediaPipeline"]>>>,
    ParentType,
    ContextType,
    RequireFields<MutationStartBulkGenerateVttFilesArgs, "job">
  >;
  startBulkIiiFConversion?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType,
    Partial<MutationStartBulkIiiFConversionArgs>
  >;
  startBulkMediaPipelineConcat?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["RecordMeetingResponse"]>>>,
    ParentType,
    ContextType,
    RequireFields<MutationStartBulkMediaPipelineConcatArgs, "paginate">
  >;
  startBulkThumbnailConversion?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType,
    Partial<MutationStartBulkThumbnailConversionArgs>
  >;
  startFhdMeeting?: Resolver<
    Maybe<ResolversTypes["StartMeetingResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationStartFhdMeetingArgs, "id" | "input">
  >;
  startMediaPipelineConcat?: Resolver<
    Maybe<ResolversTypes["RecordMeetingResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationStartMediaPipelineConcatArgs, "id">
  >;
  toggleMuteLock?: Resolver<
    Maybe<ResolversTypes["muteLockResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationToggleMuteLockArgs, "id">
  >;
  toggleVideoOffLock?: Resolver<
    Maybe<ResolversTypes["videoOffLockResponse"]>,
    ParentType,
    ContextType,
    RequireFields<MutationToggleVideoOffLockArgs, "id">
  >;
  updateUsers?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    Partial<MutationUpdateUsersArgs>
  >;
};

export type OrganizationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Organization"] = ResolversParentTypes["Organization"]
> = {
  courses?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Course"]>>>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  revokedUsers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["User"]>>>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  userOrganizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["UserOrganization"]>>>,
    ParentType,
    ContextType
  >;
  users?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["User"]>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PanoramaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Panorama"] = ResolversParentTypes["Panorama"]
> = {
  back?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  bottom?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  collection?: Resolver<
    Maybe<ResolversTypes["PanoramaCollection"]>,
    ParentType,
    ContextType
  >;
  front?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  left?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  right?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sourceUrl?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  top?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PresentationVersionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["PresentationVersion"] = ResolversParentTypes["PresentationVersion"]
> = {
  content?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ReplayBoard"]>>>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  versionNumber?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessRecordingReqBodyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["ProcessRecordingReqBody"] = ResolversParentTypes["ProcessRecordingReqBody"]
> = {
  attendeeIds?: Resolver<
    Array<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  concatFolder?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  concatRecordingBucket?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  local?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  mediaPipelineId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  queue?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recordingAccessPoint?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  recordingFolder?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  skipConcat?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Query"] = ResolversParentTypes["Query"]
> = {
  checkIsActiveFeature?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType,
    Partial<QueryCheckIsActiveFeatureArgs>
  >;
  getAllActiveFeatureFlags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["FeatureFlag"]>>>,
    ParentType,
    ContextType
  >;
  getAllAttendees?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Attendee"]>>>,
    ParentType,
    ContextType
  >;
  getAllBoards?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Board"]>>>,
    ParentType,
    ContextType
  >;
  getAllCourses?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Course"]>>>,
    ParentType,
    ContextType
  >;
  getAllFeatureFlags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["FeatureFlag"]>>>,
    ParentType,
    ContextType
  >;
  getAllImageUploads?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType
  >;
  getAllMeetings?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Meeting"]>>>,
    ParentType,
    ContextType
  >;
  getAllOrganizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Organization"]>>>,
    ParentType,
    ContextType
  >;
  getAllPanoramas?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Panorama"]>>>,
    ParentType,
    ContextType
  >;
  getAllRoles?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Role"]>>>,
    ParentType,
    ContextType
  >;
  getAllUserOrganizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["UserOrganization"]>>>,
    ParentType,
    ContextType
  >;
  getAllUsers?: Resolver<
    Maybe<Array<ResolversTypes["User"]>>,
    ParentType,
    ContextType
  >;
  getAllVideos?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["BoardVideo"]>>>,
    ParentType,
    ContextType
  >;
  getAttendee?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetAttendeeArgs, "id">
  >;
  getAttendeeByExternalId?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetAttendeeByExternalIdArgs, "externalId">
  >;
  getAuthenticatedUser?: Resolver<
    Maybe<ResolversTypes["LoginResponse"]>,
    ParentType,
    ContextType
  >;
  getBoard?: Resolver<
    Maybe<ResolversTypes["Board"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetBoardArgs, "id">
  >;
  getBoardPanorama?: Resolver<
    Maybe<ResolversTypes["BoardPanorama"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetBoardPanoramaArgs, "id">
  >;
  getBoardVideo?: Resolver<
    Maybe<ResolversTypes["BoardVideo"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetBoardVideoArgs, "id">
  >;
  getCourse?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetCourseArgs, "id">
  >;
  getCourseBySlug?: Resolver<
    Maybe<ResolversTypes["Course"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetCourseBySlugArgs, "slug">
  >;
  getCourseMeetings?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Meeting"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetCourseMeetingsArgs, "id">
  >;
  getCoursesByMeetingDates?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Course"]>>>,
    ParentType,
    ContextType,
    Partial<QueryGetCoursesByMeetingDatesArgs>
  >;
  getImageUploadByUserId?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetImageUploadByUserIdArgs, "userId">
  >;
  getMeeting?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetMeetingArgs, "id">
  >;
  getMeetingBoards?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Board"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetMeetingBoardsArgs, "meetingId">
  >;
  getMeetingBoardsByMeetingTitle?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Board"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetMeetingBoardsByMeetingTitleArgs, "meetingTitle">
  >;
  getMeetingByTitle?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetMeetingByTitleArgs, "title">
  >;
  getOrganization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetOrganizationArgs, "id">
  >;
  getOrganizationsByIds?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Organization"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetOrganizationsByIdsArgs, "ids">
  >;
  getPanorama?: Resolver<
    Maybe<ResolversTypes["Panorama"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetPanoramaArgs, "id">
  >;
  getPresentationVersion?: Resolver<
    Maybe<ResolversTypes["PresentationVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetPresentationVersionArgs, "id">
  >;
  getPresentationVersionsForMeeting?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["PresentationVersion"]>>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetPresentationVersionsForMeetingArgs, "meetingId">
  >;
  getReplayMeeting?: Resolver<
    Maybe<ResolversTypes["Meeting"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetReplayMeetingArgs, "title">
  >;
  getRole?: Resolver<
    Maybe<ResolversTypes["Role"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetRoleArgs, "id">
  >;
  getUser?: Resolver<
    Maybe<ResolversTypes["User"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetUserArgs, "id">
  >;
  getUserOrganization?: Resolver<
    Maybe<ResolversTypes["UserOrganization"]>,
    ParentType,
    ContextType
  >;
  root?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  searchArtObjects?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ArtObject"]>>>,
    ParentType,
    ContextType,
    Partial<QuerySearchArtObjectsArgs>
  >;
  searchImageUploads?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ImageUpload"]>>>,
    ParentType,
    ContextType,
    Partial<QuerySearchImageUploadsArgs>
  >;
};

export type RecordMeetingResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["RecordMeetingResponse"] = ResolversParentTypes["RecordMeetingResponse"]
> = {
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  initVersionNumber?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  mediaPipeline?: Resolver<
    Maybe<ResolversTypes["MediaPipeline"]>,
    ParentType,
    ContextType
  >;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  status?: Resolver<
    Maybe<ResolversTypes["RecordMeetingStatus"]>,
    ParentType,
    ContextType
  >;
  success?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayBoardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["ReplayBoard"] = ResolversParentTypes["ReplayBoard"]
> = {
  BoardImages?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ReplayBoardImage"]>>>,
    ParentType,
    ContextType
  >;
  BoardPanorama?: Resolver<
    Maybe<ResolversTypes["BoardPanoramaReplay"]>,
    ParentType,
    ContextType
  >;
  BoardThreedee?: Resolver<
    Maybe<ResolversTypes["BoardThreedee"]>,
    ParentType,
    ContextType
  >;
  BoardVideo?: Resolver<
    Maybe<ResolversTypes["BoardVideo"]>,
    ParentType,
    ContextType
  >;
  caption?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  meetingId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes["BoardType"]>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayBoardImageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["ReplayBoardImage"] = ResolversParentTypes["ReplayBoardImage"]
> = {
  ImageUpload?: Resolver<
    Maybe<ResolversTypes["ImageUpload"]>,
    ParentType,
    ContextType
  >;
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  boardId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  boardImageLayers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["BoardImageLayer"]>>>,
    ParentType,
    ContextType
  >;
  height?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  imageUploadId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tileSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Role"] = ResolversParentTypes["Role"]
> = {
  canCreateDemoMeeting?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  canLogin?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  isVisible?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionCookieResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["SessionCookie"] = ResolversParentTypes["SessionCookie"]
> = {
  maxAge?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionObjectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["SessionObject"] = ResolversParentTypes["SessionObject"]
> = {
  attendeeId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  cookie?: Resolver<
    Maybe<ResolversTypes["SessionCookie"]>,
    ParentType,
    ContextType
  >;
  initialized?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isAuthenticated?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  organizationIds?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Int"]>>>,
    ParentType,
    ContextType
  >;
  permissions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["SessionPermission"]>>>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionPermissionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["SessionPermission"] = ResolversParentTypes["SessionPermission"]
> = {
  organizationId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  role?: Resolver<Maybe<ResolversTypes["Role"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartMeetingResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["StartMeetingResponse"] = ResolversParentTypes["StartMeetingResponse"]
> = {
  attendee?: Resolver<
    Maybe<ResolversTypes["Attendee"]>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  initVersionNumber?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  recordMeetingStatus?: Resolver<
    Maybe<ResolversTypes["RecordMeetingStatus"]>,
    ParentType,
    ContextType
  >;
  startMeetingSuccess?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBoardImageResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UpdateBoardImageResponse"] = ResolversParentTypes["UpdateBoardImageResponse"]
> = {
  boardImages?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["BoardImage"]>>>,
    ParentType,
    ContextType
  >;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBoardPanoramaResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UpdateBoardPanoramaResponse"] = ResolversParentTypes["UpdateBoardPanoramaResponse"]
> = {
  boardPanorama?: Resolver<
    Maybe<ResolversTypes["BoardPanorama"]>,
    ParentType,
    ContextType
  >;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBoardResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UpdateBoardResponse"] = ResolversParentTypes["UpdateBoardResponse"]
> = {
  board?: Resolver<Maybe<ResolversTypes["Board"]>, ParentType, ContextType>;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBoardThreedeeResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UpdateBoardThreedeeResponse"] = ResolversParentTypes["UpdateBoardThreedeeResponse"]
> = {
  boardThreedee?: Resolver<
    Maybe<ResolversTypes["BoardThreedee"]>,
    ParentType,
    ContextType
  >;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBoardVideoResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UpdateBoardVideoResponse"] = ResolversParentTypes["UpdateBoardVideoResponse"]
> = {
  boardVideo?: Resolver<
    Maybe<ResolversTypes["BoardVideo"]>,
    ParentType,
    ContextType
  >;
  currentVersion?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["User"] = ResolversParentTypes["User"]
> = {
  createdAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  firstName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["Organization"]>>>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  userOrganizations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["UserOrgWithRole"]>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgWithRoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UserOrgWithRole"] = ResolversParentTypes["UserOrgWithRole"]
> = {
  id?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  organization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType
  >;
  organizationId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  role?: Resolver<Maybe<ResolversTypes["Role"]>, ParentType, ContextType>;
  userID?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrganizationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["UserOrganization"] = ResolversParentTypes["UserOrganization"]
> = {
  createdAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  organization?: Resolver<
    Maybe<ResolversTypes["Organization"]>,
    ParentType,
    ContextType
  >;
  organizationId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes["Role"]>, ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes["User"]>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MuteLockResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["muteLockResponse"] = ResolversParentTypes["muteLockResponse"]
> = {
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoOffLockResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["videoOffLockResponse"] = ResolversParentTypes["videoOffLockResponse"]
> = {
  error?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes["Meeting"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ArtObject?: ArtObjectResolvers<ContextType>;
  Attendee?: AttendeeResolvers<ContextType>;
  Board?: BoardResolvers<ContextType>;
  BoardImage?: BoardImageResolvers<ContextType>;
  BoardImageLayer?: BoardImageLayerResolvers<ContextType>;
  BoardPanorama?: BoardPanoramaResolvers<ContextType>;
  BoardPanoramaReplay?: BoardPanoramaReplayResolvers<ContextType>;
  BoardThreedee?: BoardThreedeeResolvers<ContextType>;
  BoardVideo?: BoardVideoResolvers<ContextType>;
  Course?: CourseResolvers<ContextType>;
  CreateDemoMeetingResponse?: CreateDemoMeetingResponseResolvers<ContextType>;
  CreateUserResponse?: CreateUserResponseResolvers<ContextType>;
  DeleteChimeAttendeeResponse?: DeleteChimeAttendeeResponseResolvers<ContextType>;
  DeleteMeetingResponse?: DeleteMeetingResponseResolvers<ContextType>;
  DeletedBoard?: DeletedBoardResolvers<ContextType>;
  DeletedBoardImage?: DeletedBoardImageResolvers<ContextType>;
  DeletedCourse?: DeletedCourseResolvers<ContextType>;
  DeviceInfo?: DeviceInfoResolvers<ContextType>;
  EndMeetingResponse?: EndMeetingResponseResolvers<ContextType>;
  FeatureFlag?: FeatureFlagResolvers<ContextType>;
  IiifConversionReqBody?: IiifConversionReqBodyResolvers<ContextType>;
  IiifConversionResponse?: IiifConversionResponseResolvers<ContextType>;
  ImageUpload?: ImageUploadResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Job?: JobResolvers<ContextType>;
  JobResponse?: JobResponseResolvers<ContextType>;
  LoginResponse?: LoginResponseResolvers<ContextType>;
  LogoutResponse?: LogoutResponseResolvers<ContextType>;
  MediaPipeline?: MediaPipelineResolvers<ContextType>;
  Meeting?: MeetingResolvers<ContextType>;
  MeetingError?: MeetingErrorResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  Panorama?: PanoramaResolvers<ContextType>;
  PresentationVersion?: PresentationVersionResolvers<ContextType>;
  ProcessRecordingReqBody?: ProcessRecordingReqBodyResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RecordMeetingResponse?: RecordMeetingResponseResolvers<ContextType>;
  ReplayBoard?: ReplayBoardResolvers<ContextType>;
  ReplayBoardImage?: ReplayBoardImageResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  SessionCookie?: SessionCookieResolvers<ContextType>;
  SessionObject?: SessionObjectResolvers<ContextType>;
  SessionPermission?: SessionPermissionResolvers<ContextType>;
  StartMeetingResponse?: StartMeetingResponseResolvers<ContextType>;
  UpdateBoardImageResponse?: UpdateBoardImageResponseResolvers<ContextType>;
  UpdateBoardPanoramaResponse?: UpdateBoardPanoramaResponseResolvers<ContextType>;
  UpdateBoardResponse?: UpdateBoardResponseResolvers<ContextType>;
  UpdateBoardThreedeeResponse?: UpdateBoardThreedeeResponseResolvers<ContextType>;
  UpdateBoardVideoResponse?: UpdateBoardVideoResponseResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserOrgWithRole?: UserOrgWithRoleResolvers<ContextType>;
  UserOrganization?: UserOrganizationResolvers<ContextType>;
  muteLockResponse?: MuteLockResponseResolvers<ContextType>;
  videoOffLockResponse?: VideoOffLockResponseResolvers<ContextType>;
};

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
};
export default result;
